window.WAC_TP_ROUTES =
[
  {
    "id": "amsterdam-to-bangkok-the-ultimate-overland-campervan-odyssey",
    "title": "Amsterdam to Asia: The Ultimate Campervan Odyssey",
    "passions": [],
    "pick_up_country": "coming soon",
    "pick_up_location": "coming soon",
    "route_source": "Shopify export",
    "status": "coming soon",
    "provenance": "local expert",
    "days_total": "coming soon",
    "distance_km": "coming soon",
    "toy": null,
    "days": []
  },
  {
    "id": "cape-town-marathon-campervan-roadtrip",
    "title": "🏁 Warm Up for the Cape Town Marathon: A Garden Route Campervan Road Trip",
    "passions": [],
    "pick_up_country": "",
    "pick_up_location": "",
    "route_source": "Shopify export",
    "status": "complete",
    "provenance": "local expert",
    "days_total": null,
    "distance_km": null,
    "toy": null,
    "days": [
      {
        "day": 1,
        "name": "Pick Up in Port Elizabeth & Addo Elephant Park NP",
        "drive": "🚐 Drive time: ~1 hour.",
        "start": "",
        "end": "Pick Up in Port Elizabeth &",
        "text": "Collect your campervan and drive to Addo Elephant Park. Enjoy a thrilling afternoon of self-drive game viewing and the excitement of seeing elephants, buffalo, and zebras up close. Stay overnight at the main rest camp campsite, sleep under the African stars, and enjoy a local meal in the camp restaurant.\n\n🗓️",
        "passions": [],
        "lodging": "camper"
      },
      {
        "day": 2,
        "name": "Addo",
        "drive": "",
        "start": "Pick Up in Port Elizabeth &",
        "end": "Addo",
        "text": "Start the day with a morning trail run along the park’s designated hiking path – a rare opportunity to jog in a wildlife reserve where you might glimpse antelope. After breakfast, explore the park, which spans over 1,640 square kilometers.\n🏃 Suggested run distance: 5–8 km.\n\n🗓️",
        "passions": [],
        "lodging": "camper"
      },
      {
        "day": 3,
        "name": "Leave Addo and Overnight in Tsitsikamma National Park",
        "drive": "🚐 Drive time: ~2.5 hours.",
        "start": "Addo",
        "end": "Leave Addo and Overnight in Tsitsikamma",
        "text": "Depart Addo taking a further chance to spot wildlife. Drive south to Tsitsikamma and set up camp beside the dramatic coastline, where waves crash against ancient cliffs. Take an easy walk among giant yellowwood trees.\n\n🗓️",
        "passions": [],
        "lodging": "camper"
      },
      {
        "day": 4,
        "name": "Tsitsikamma Run, Knysna Lunch & Wilderness Camp",
        "drive": "🚐 Drive time: ~2 hours.",
        "start": "Leave Addo and Overnight in Tsitsikamma",
        "end": "Tsitsikamma Run, Knysna Lunch & Wilderness",
        "text": "Begin your morning with a pre-breakfast run on the Storms River coastal trail, with panoramic ocean views and fresh sea air. After breakfast, drive to Knysna for lunch and time to explore the waterfront. Continue to Wilderness campsite for the night.\n🏃 Suggested run distance: 5–10 km.\n\n🗓️",
        "passions": [],
        "lodging": "camper"
      },
      {
        "day": 5,
        "name": "Morning Beach Run & Karoo Crossing to Worcester",
        "drive": "🚐 Drive time: ~4.5 hours.",
        "start": "Tsitsikamma Run, Knysna Lunch & Wilderness",
        "end": "Morning Beach Run & Karoo Crossing",
        "text": "Wake early for a refreshing barefoot run on Wilderness Beach, stretching for miles along the Indian Ocean. Drive across the Karoo, enjoying the vast open spaces as you drive across the interior of Western Cape. Arrive in Worcester for a restaurant meal of great food and wine.\n🏃 Suggested run distance: 5–7 km.\n\n🗓️",
        "passions": [],
        "lodging": "camper"
      },
      {
        "day": 6,
        "name": "Stellenbosch Run & Vineyard Relaxation",
        "drive": "🚐 Drive time: ~1.5 hours.",
        "start": "Morning Beach Run & Karoo Crossing",
        "end": "Stellenbosch Run & Vineyard Relaxation",
        "text": "Drive to Stellenbosch and take an easy run through Jonkershoek trails, with shaded paths and mountain views. Later, enjoy a relaxed lunch and tasting at your choice of the many great wine estates in the area.\n🏃 Suggested run distance: 4-5 km.\n\n🗓️",
        "passions": [],
        "lodging": "camper"
      },
      {
        "day": 7,
        "name": "Relaxation in Winelands (or transfer to Cape Town if you are running 5k, 10km or trail events)",
        "drive": "",
        "start": "Stellenbosch Run & Vineyard Relaxation",
        "end": "Relaxation in Winelands (or transfer to",
        "text": "Enjoy a slow morning in the vineyards—sleep in, stroll through Stellenbosch’s oak-lined streets, visit an art gallery or farm shop, or simply unwind at your campsite with a book and a glass of local wine. Those participating in the 5k, 10km, or trail events can transfer to Cape Town in the afternoon to be ready for race logistics the next day.\n\n🗓️",
        "passions": [],
        "lodging": "camper"
      },
      {
        "day": 8,
        "name": "Vineyard Breakfast & Cape Town Transfer",
        "drive": "🚐 Drive time: ~1 hour.",
        "start": "Relaxation in Winelands (or transfer to",
        "end": "Vineyard Breakfast & Cape Town Transfer",
        "text": "Have a final vineyard breakfast such as at Jordan Wine Estate, then drive into Cape Town to drop off your campervan and check in to your hotel. Spend the afternoon exploring Bo-Kaap and the V&A Waterfront.\n\n🗓️",
        "passions": [],
        "lodging": "hotel"
      },
      {
        "day": 8,
        "name": "Cape Town Marathon Race day!",
        "drive": "",
        "start": "Vineyard Breakfast & Cape Town Transfer",
        "end": "Cape Town Marathon Race day",
        "text": "Wake refreshed, walk to the start, and enjoy the Cape Town Marathon. Celebrate with your group afterward.\n\n🗓️",
        "passions": [],
        "lodging": "camper"
      },
      {
        "day": 9,
        "name": "Recovery Day / Enjoy Cape Town",
        "drive": "",
        "start": "Cape Town Marathon Race day",
        "end": "Recovery Day / Enjoy Cape Town",
        "text": "Relax and recover, visit Camps Bay beach or stroll the city.\n\n🗓️",
        "passions": [],
        "lodging": "camper"
      },
      {
        "day": 10,
        "name": "Departure",
        "drive": "",
        "start": "Recovery Day / Enjoy Cape Town",
        "end": "Departure",
        "text": "Savour breakfast overlooking Table Mountain before heading home.",
        "passions": [],
        "lodging": "camper"
      }
    ]
  },
  {
    "id": "champagne-balloon-and-countryside-escape-france-wine-country-adventure",
    "title": "Champagne Balloon & Countryside Escape: France Wine Country Adventure",
    "passions": [
      "wine",
      "dining",
      "scenery",
      "history"
    ],
    "pick_up_country": "",
    "pick_up_location": "",
    "route_source": "Shopify export",
    "status": "complete",
    "provenance": "hand curated",
    "days_total": null,
    "distance_km": null,
    "toy": null,
    "days": [
      {
        "day": 1,
        "name": "Arrival in Reims &amp; Campground Check-in",
        "drive": "🚐 Drive time: ~2 hrs from Paris",
        "start": "",
        "end": "Arrival in Reims & Campground Check-in",
        "text": "Pick up your camper in Reims or Paris and head into the Champagne countryside. Settle into a peaceful campsite near the vineyards of Rilly-la-Montagne, Aÿ, or Les Riceys.",
        "passions": [
          "wine"
        ],
        "lodging": "camper"
      },
      {
        "day": 2,
        "name": "Balloon Flight &amp; Champagne Cellars",
        "drive": "",
        "start": "Arrival in Reims & Campground Check-in",
        "end": "Balloon Flight & Champagne Cellars",
        "text": "Rise early for your balloon flight from a nearby launch site. After landing and celebrating, visit one of the boutique Champagne producers in Bouzy, Aÿ, or Hautvillers. Sample vintages and enjoy a picnic among the vines.",
        "passions": [
          "wine"
        ],
        "lodging": "camper"
      },
      {
        "day": 3,
        "name": "Route du Champagne &amp; Vineyard Stay",
        "drive": "",
        "start": "Balloon Flight & Champagne Cellars",
        "end": "Route du Champagne & Vineyard Stay",
        "text": "Drive the Route du Champagne, stopping in villages like Hautvillers (home of Dom Pérignon), Dizy, and Cumières. Visit small family-run cellars or head to Les Riceys for a more immersive stay at Champagne Pascal Walczak—complete with tastings and van-friendly vineyard parking.",
        "passions": [
          "wine"
        ],
        "lodging": "camper"
      },
      {
        "day": 4,
        "name": "Épernay Day Trip or Relaxed Glamping",
        "drive": "",
        "start": "Route du Champagne & Vineyard Stay",
        "end": "Épernay Day Trip or Relaxed Glamping",
        "text": "Spend your day on the famed Avenue de Champagne in Épernay, visiting grand houses like Moët &amp; Chandon or walking the riverside. Or opt for a unique glamping experience at Champagne Perron-Beauvineau, complete with a hosted meal and breakfast delivery.",
        "passions": [
          "wine"
        ],
        "lodging": "camper"
      },
      {
        "day": 5,
        "name": "(Optional) – Châlons-en-Champagne &amp; Canal Ride",
        "drive": "🚐 Drive time: ~1 hr",
        "start": "Épernay Day Trip or Relaxed Glamping",
        "end": "(Optional) – Châlons-en-Champagne & Canal Ride",
        "text": "Extend your stay with a detour to Châlons-en-Champagne for canal boat tours, flower markets, and peaceful streets. Camp nearby and enjoy a final sunset toast.",
        "passions": [
          "wine",
          "scenery"
        ],
        "lodging": "camper"
      },
      {
        "day": 6,
        "name": "Return to Paris &amp; Camper Drop-off",
        "drive": "🚐 Drive time: ~2 hrs from Châlons-en-Champagne or ~1.5 hrs from Épernay",
        "start": "(Optional) – Châlons-en-Champagne & Canal Ride",
        "end": "Paris & Camper Drop-off",
        "text": "Drive back to Paris to return your camper. Depending on your timing, enjoy a final stop in Reims for a last stroll or lunch along the canal. Plan for traffic near the city and allow extra time for camper return.",
        "passions": [
          "dining"
        ],
        "lodging": "camper"
      }
    ]
  },
  {
    "id": "family-beach-forest-city-roadtrip-netherlands",
    "title": "Family Beach, Forest & City Roadtrip of the Netherlands",
    "passions": [
      "family",
      "theme-park",
      "beach",
      "cycling",
      "nature",
      "culture"
    ],
    "pick_up_country": "",
    "pick_up_location": "",
    "route_source": "Shopify export",
    "status": "complete",
    "provenance": "local expert",
    "days_total": 12,
    "distance_km": 800,
    "toy": null,
    "days": [
      {
        "day": 1,
        "name": "Pick up in Amsterdam & Settle at Duinrell",
        "drive": "🚐 Drive time: ~40 minutes",
        "start": "",
        "end": "Pick up in Amsterdam & Settle",
        "text": "Collect your camper in Amsterdam and drive a short distance to Duinrell. This holiday park is unique in combining a full amusement park, forest trails, and on-site camping, so children can dive straight into rides while parents enjoy the convenience of a single base. For dinner, head to Beachclub Bida Baai nearby for Dutch coastal vibes and your first taste of sea air.",
        "passions": [
          "beach",
          "nature"
        ],
        "lodging": "camper"
      },
      {
        "day": 2,
        "name": "Full Park Day",
        "drive": "🚐 Drive time: none",
        "start": "Pick up in Amsterdam & Settle",
        "end": "Full Park Day",
        "text": "Spend the entire day at Duinrell with unlimited access to its rollercoasters, playgrounds, and shows. On hot days or rainy afternoons, the Tiki Pool offers Europe’s longest indoor waterslides, making it a rare all-weather highlight for families. Being able to walk back to your camper whenever you need a break keeps the pace relaxed and stress-free.",
        "passions": [
          "beach",
          "nature"
        ],
        "lodging": "camper",
        "experiences": [
          "duinrell-family-themepark-campervan-trip"
        ]
      },
      {
        "day": 3,
        "name": "Coast & Culture",
        "drive": "🚐 Drive time: ~20 minutes if visiting The Hague",
        "start": "Full Park Day",
        "end": "Coast & Culture",
        "text": "Cycle forest trails to Wassenaar Beach, a wide stretch of dunes and sand where Dutch families spend summer weekends. Add in a half-day visit to The Hague, home to the Mauritshuis (with Vermeer’s “Girl with a Pearl Earring”) and Madurodam, a miniature version of the whole country that kids love. This day captures the Dutch balance of seaside leisure and city culture.",
        "passions": [
          "beach",
          "nature",
          "culture"
        ],
        "lodging": "camper"
      },
      {
        "day": 4,
        "name": "Duinrell Bonus Day + Delft",
        "drive": "🚐 Drive time: ~30 minutes if visiting Delft",
        "start": "Coast & Culture",
        "end": "Duinrell Bonus Day + Delft",
        "text": "Take it slower today, either repeating your favorite rides or heading into Delft. Known for its blue pottery and as Vermeer’s birthplace, Delft is one of the Netherlands’ prettiest old towns, with canals, market squares, and a charming small-city feel. It’s a reminder of Dutch history and craftsmanship set just a short drive from the fun of Duinrell.",
        "passions": [
          "culture"
        ],
        "lodging": "camper"
      },
      {
        "day": 5,
        "name": "Friesland Lakes",
        "drive": "🚐 Drive time: ~1.5–2 hours",
        "start": "Duinrell Bonus Day + Delft",
        "end": "Friesland Lakes",
        "text": "Drive north into Friesland, a region that feels like a different country within the Netherlands. Its lakes are surrounded by small sailing towns, cycle routes, and traditional farms, creating a calm, rural atmosphere. Settle at a lakeside campsite for SUP boarding, swimming, or exploring towns like Sneek and Heeg.",
        "passions": [
          "nature"
        ],
        "lodging": "camper",
        "experiences": [
          "sneek-lakes-boating-and-camping-experience"
        ]
      },
      {
        "day": 6,
        "name": "Friesland Local Life + Leeuwarden",
        "drive": "🚐 Drive time: ~30 minutes if visiting Leeuwarden",
        "start": "Friesland Lakes",
        "end": "Friesland Local Life + Leeuwarden",
        "text": "Spend another day immersed in Friesland. Visit Leeuwarden, the provincial capital, with its leaning tower, canals, and lively markets. Friesland is known for its proud identity, own language, and slower pace — a contrast to the busier cities of the west — making it perfect for families seeking space and authenticity.",
        "passions": [],
        "lodging": "camper"
      },
      {
        "day": 7,
        "name": "Terschelling Island",
        "drive": "",
        "start": "Friesland Local Life + Leeuwarden",
        "end": "Terschelling Island",
        "text": "Catch the ferry to Terschelling, one of the Wadden Islands protected as a UNESCO World Heritage site. With car-free villages, endless beaches, and wild dune landscapes, it feels far removed from the mainland. Families can bike the island end-to-end, explore lighthouses, and enjoy quiet evenings in cozy restaurants.\n🚐 Drive time to ferry: ~1 hour + ferry",
        "passions": [
          "beach",
          "culture"
        ],
        "lodging": "camper"
      },
      {
        "day": 8,
        "name": "Veluwe National Park (Relax + Museum)",
        "drive": "🚐 Drive time: ~2.5 hours",
        "start": "Terschelling Island",
        "end": "Veluwe National Park (Relax + Museum)",
        "text": "Head inland to the Veluwe, the Netherlands’ largest forest and heathland reserve. It’s special not only for its wildlife — red deer, boar, and rare birds — but also for the Kröller-Müller Museum, which has one of the world’s largest Van Gogh collections set inside the park. Few places combine art, nature, and adventure so seamlessly.",
        "passions": [
          "beach",
          "nature",
          "culture"
        ],
        "lodging": "camper",
        "experiences": [
          "wild-talk-guided-walk-and-bbq-in-the-veluwe"
        ]
      },
      {
        "day": 9,
        "name": "Veluwe (Mountain Biking & Nature)",
        "drive": "🚐 Drive time: none",
        "start": "Veluwe National Park (Relax + Museum)",
        "end": "Veluwe (Mountain Biking & Nature)",
        "text": "Stay a second day in the Veluwe for deeper exploration. The park is laced with sandy trails ideal for mountain biking, and there are guided walks to spot wildlife at dawn or dusk. Evening campfires in designated areas let families experience the forest in a way that feels both adventurous and safe.",
        "passions": [
          "nature"
        ],
        "lodging": "camper"
      },
      {
        "day": 10,
        "name": "Return Camper & City Arrival",
        "drive": "🚐 Drive time: ~1.5 hours",
        "start": "Veluwe (Mountain Biking & Nature)",
        "end": "Return Camper & City Arrival",
        "text": "Return to Amsterdam and hand back your campervan, but the journey isn’t over. Switching to a city hotel or apartment, you can dive straight into canal boat rides, markets, or Vondelpark strolls. It’s a smooth landing into city life after days of nature and rural calm.",
        "passions": [
          "nature"
        ],
        "lodging": "hotel"
      },
      {
        "day": "11 & 12",
        "name": "Explore Amsterdam & Depart",
        "drive": "🚐 Drive time: none",
        "start": "Return Camper & City Arrival",
        "end": "Explore Amsterdam & Depart",
        "text": "Spend your final days exploring Amsterdam. Kids can spend hours in the NEMO Science Museum, while parents enjoy the Rijksmuseum, Van Gogh Museum, or boutique shopping. Ending here ties together the whole trip: culture, play, and a taste of Dutch urban life before departure.",
        "passions": [
          "culture"
        ],
        "lodging": "hotel"
      },
      {
        "day": "11 & 12",
        "name": "Explore Amsterdam & Depart",
        "drive": "🚐 Drive time: none",
        "start": "Return Camper & City Arrival",
        "end": "Explore Amsterdam & Depart",
        "text": "Spend your final days exploring Amsterdam. Kids can spend hours in the NEMO Science Museum, while parents enjoy the Rijksmuseum, Van Gogh Museum, or boutique shopping. Ending here ties together the whole trip: culture, play, and a taste of Dutch urban life before departure.",
        "passions": [
          "culture"
        ],
        "lodging": "hotel"
      }
    ]
  },
  {
    "id": "family-beach-safari-motorhome-trip-to-garden-route",
    "title": "Family Beach & Safari Adventure through Garden Route to Cape Town by RV",
    "passions": [
      "safari",
      "nature",
      "hiking",
      "family",
      "dinosaurs"
    ],
    "pick_up_country": "Cape Town",
    "pick_up_location": "South Africa",
    "route_source": "Shopify export",
    "status": "complete",
    "provenance": "local expert",
    "days_total": "11-15",
    "distance_km": 950,
    "toy": null,
    "days": [
      {
        "day": 1,
        "name": "Collect RV from Port Elizabeth",
        "drive": "🚐 Drive time: ~1.5 hrs",
        "start": "",
        "end": "Collect RV from Port Elizabeth",
        "text": "Collect your camper andd rive to Addo Elephant Park for your first night under the stars. Camp in the South Africa National Parks campsite near the gate or in a nearby bush lodge.",
        "passions": [
          "nature",
          "hiking"
        ],
        "lodging": "camper",
        "experiences": [
          "watch-big-5-from-your-lunch-table"
        ]
      },
      {
        "day": 2,
        "name": "Addo Elephant Safari",
        "drive": "🚐 Drive time: flexible inside park",
        "start": "Collect RV from Port Elizabeth",
        "end": "Addo Elephant Safari",
        "text": "Spend a full day self-driving through the reserve. Watch elephants from your camper and enjoy lunch while giraffes stroll nearby.",
        "passions": [
          "safari",
          "nature"
        ],
        "lodging": "camper"
      },
      {
        "day": 3,
        "name": "Addo to Knysna via Tsitsikamma",
        "drive": "🚐 Drive time: ~5 hrs",
        "start": "Addo Elephant Safari",
        "end": "Addo to Knysna via Tsitsikamma",
        "text": "Drive along the scenic N2 through lush forest and cliffs. Stop at Tsitsikamma for a short coastal walk before reaching Knysna.",
        "passions": [
          "nature",
          "hiking"
        ],
        "lodging": "camper"
      },
      {
        "day": 4,
        "name": "Knysna Forest & Lagoon",
        "drive": "🚐 Drive time: none",
        "start": "Addo to Knysna via Tsitsikamma",
        "end": "Knysna Forest & Lagoon",
        "text": "Walk the Knysna heads or ride bikes along the forest edge. Enjoy a sunset picnic at the water’s edge.",
        "passions": [
          "nature",
          "hiking"
        ],
        "lodging": "camper"
      },
      {
        "day": 5,
        "name": "Knysna to Wilderness National Park",
        "drive": "🚐 Drive time: ~1.5 hrs",
        "start": "Knysna Forest & Lagoon",
        "end": "Knysna to Wilderness National Park",
        "text": "Head further west to Wilderness and check into a riverside or forest campsite. Explore the nearby lakes and long beaches.",
        "passions": [
          "nature"
        ],
        "lodging": "camper"
      },
      {
        "day": 6,
        "name": "Canoeing & Forest Trails",
        "drive": "🚐 Drive time: none",
        "start": "Knysna to Wilderness National Park",
        "end": "Canoeing & Forest Trails",
        "text": "Paddle the calm river loops or walk shaded paths in the national park. Spot kingfishers and picnic on the bank.",
        "passions": [
          "nature",
          "hiking"
        ],
        "lodging": "camper"
      },
      {
        "day": 7,
        "name": "To Garden Route Game Lodge",
        "drive": "🚐 Drive time: ~2 hrs",
        "start": "Canoeing & Forest Trails",
        "end": "To Garden Route Game Lodge",
        "text": "Make your way to the lodge near Albertinia for your treat night. Check into a room, swim, and enjoy an evening safari with sundowners.",
        "passions": [
          "safari"
        ],
        "lodging": "camper"
      },
      {
        "day": 8,
        "name": "Whale Coast & L’Agulhas",
        "drive": "🚐 Drive time: ~3.5 hrs",
        "start": "To Garden Route Game Lodge",
        "end": "Whale Coast & L’Agulhas",
        "text": "Drive down to the Whale Coast, stopping in Hermanus or Gansbaai. Continue to L’Agulhas for dramatic ocean views and boardwalks.",
        "passions": [
          "hiking"
        ],
        "lodging": "camper"
      },
      {
        "day": "9 & 10",
        "name": "L’Agulhas to Stellenbosch or Winelands",
        "drive": "🚐 Drive time: ~2.5 hrs",
        "start": "Whale Coast & L’Agulhas",
        "end": "L’Agulhas to Stellenbosch or Winelands",
        "text": "Stop in a wine farm or quiet inland town for a final camping or lunch stop before the city.",
        "passions": [],
        "lodging": "camper",
        "experiences": [
          "stay-with-your-rv-in-a-winelands-vineyard"
        ]
      },
      {
        "day": 11,
        "name": "Return Camper & Cape Town City Stay (Night 1)",
        "drive": "🚐 Drive time: ~1.5 hrs",
        "start": "L’Agulhas to Stellenbosch or Winelands",
        "end": "Return Camper & Cape Town City",
        "text": "Return your campervan and check into a hotel or apartment in the city. Walk the V&A Waterfront or take the cable car up Table Mountain.",
        "passions": [
          "hiking"
        ],
        "lodging": "hotel"
      },
      {
        "day": 12,
        "name": "Cape Town City Explorations (Night 2)",
        "drive": "🚐 Drive time: none",
        "start": "Return Camper & Cape Town City",
        "end": "Cape Town City Explorations (Night 2)",
        "text": "Visit Robben Island, explore museums, or head to Camps Bay. Stay a second night or fly out later in the evening.",
        "passions": [],
        "lodging": "camper"
      }
    ]
  },
  {
    "id": "garden-route-golf-road-trip",
    "title": "The Garden Route’s Ultimate Golf Camper Road trip",
    "passions": [
      "golf",
      "wine",
      "dining",
      "hiking"
    ],
    "pick_up_country": "Cape Town",
    "pick_up_location": "South Africa",
    "route_source": "Shopify export",
    "status": "complete",
    "provenance": "local expert",
    "days_total": 12,
    "distance_km": 900,
    "toy": null,
    "days": [
      {
        "day": 1,
        "name": "Collect Camper & Addo Elephant Park",
        "drive": "🚐 Drive time: ~1 hour",
        "start": "",
        "end": "Collect Camper & Addo Elephant Park",
        "text": "Pick up your campervan in Port Elizabeth and drive directly to Addo Elephant Park. Begin your adventure with an afternoon self-drive safari among elephant herds and buffalo.",
        "experiences": [
          "watch-big-5-from-your-lunch-table"
        ],
        "passions": [],
        "lodging": "camper"
      },
      {
        "day": 2,
        "name": "Addo Elephant Park",
        "drive": "🚐 Drive time: none",
        "start": "Collect Camper & Addo Elephant Park",
        "end": "Addo Elephant Park",
        "text": "Spend the day exploring Addo’s diverse habitats. Watch elephants, buffalo, and kudu gathering at watering holes and enjoy sunset views from your campsite.",
        "passions": [],
        "lodging": "camper"
      },
      {
        "day": 3,
        "name": "Tsitsikamma National Park",
        "drive": "🚐 Drive time: ~3 hours",
        "start": "Addo Elephant Park",
        "end": "Tsitsikamma National Park",
        "text": "Drive west to Tsitsikamma National Park. Camp right beside the ocean with spectacular coastal views. Explore forest trails and the famous suspension bridges.",
        "passions": [
          "hiking"
        ],
        "lodging": "camper"
      },
      {
        "day": 4,
        "name": "Plettenberg Bay & Arrive Knysna",
        "drive": "🚐 Drive time: ~2.5 hours",
        "start": "Tsitsikamma National Park",
        "end": "Plettenberg Bay & Arrive Knysna",
        "text": "Enjoy lunch overlooking beautiful Plettenberg Bay Beach, famous for its long golden sands, dolphin sightings, and vibrant waterfront cafes.\n\nDrive to a campsite in Knysna, such as the Knysna Lagoon Caravan Park, which offers pitches right by the water with views of the lagoon and easy access to the town.",
        "passions": [
          "dining"
        ],
        "lodging": "camper"
      },
      {
        "day": 5,
        "name": "Simola Golf & Arrive Gondwana Private Game Reserve (Hotel night)",
        "drive": "",
        "start": "Plettenberg Bay & Arrive Knysna",
        "end": "Simola Golf & Arrive Gondwana Private",
        "text": "Morning golf at Simola Golf Club, a Jack Nicklaus Signature course with panoramic views over Knysna Lagoon and indigenous forests. Non-golfers can enjoy time exploring Knysna’s boutique shops, waterfront market, or Featherbed Nature Reserve.\n\nDrive to Gondwana Private Game Reserve, a luxury malaria-free Big Five reserve with spacious suites, a spa, and an infinity pool overlooking the mountains.\n\nOption for a sunset game drive followed by dining in the reserve’s elegant boma restaurant serving modern South African cuisine.",
        "passions": [
          "golf",
          "dining"
        ],
        "lodging": "hotel"
      },
      {
        "day": 6,
        "name": "Gondwana Private Game Reserve (Hotel night)",
        "drive": "🚐 Drive time: none",
        "start": "Simola Golf & Arrive Gondwana Private",
        "end": "Gondwana Private Game Reserve (Hotel night)",
        "text": "Morning game drive tracking lions, elephant, and rhino. Relax in the pool, book a spa treatment, join a guided bush walk, or enjoy birdwatching from your deck. Optional evening game drive before dinner under the stars.🚐 Drive time: none",
        "passions": [
          "dining",
          "hiking"
        ],
        "lodging": "hotel"
      },
      {
        "day": 7,
        "name": "Pinnacle Point Golf",
        "drive": "🚐 Drive time: ~45 minutes",
        "start": "Gondwana Private Game Reserve (Hotel night)",
        "end": "Pinnacle Point Golf",
        "text": "Another magnificent golf experience with a short drive to Pinnacle Point’s spectacular clifftop course, known for holes that play across ocean gorges and panoramic views. Camp nearby at Mossel Bay Point Caravan Park, right above the beach with excellent facilities.🚐 Drive time: ~45 minutes",
        "passions": [
          "golf"
        ],
        "lodging": "camper"
      },
      {
        "day": 8,
        "name": "Drive Mossel Bay to Winelands Camping",
        "drive": "🚐 Drive time: ~4.5 hours",
        "start": "Pinnacle Point Golf",
        "end": "Drive Mossel Bay to Winelands Camping",
        "text": "A longer but beautiful drive across the semi-arid landscapes of the Karoo and into the fertile Cape Winelands. Stop for lunch and coffee in Swellendam, a charming town with Cape Dutch architecture, and enjoy a wine tasting at Rietvallei or Springfield Estate. Finish the day setting up camp among the vineyards at Boschendal Wine Estate, which offers campervan sites with mountain views. In the afternoon, join a guided cellar tour and learn about Boschendal’s history, then enjoy a curated wine tasting with local cheeses and charcuterie. In the evening, dine in the estate’s acclaimed Werf Restaurant or have a relaxed braai at your pitch.",
        "passions": [
          "wine",
          "dining"
        ],
        "lodging": "camper"
      },
      {
        "day": 9,
        "name": "Pearl Valley Golf",
        "drive": "🚐 Drive time: ~30 minutes",
        "start": "Drive Mossel Bay to Winelands Camping",
        "end": "Pearl Valley Golf",
        "text": "Play a round at Pearl Valley, a Jack Nicklaus Signature course with immaculate fairways and mountain backdrops. Spend the afternoon exploring Stellenbosch before returning to your campsite for dinner—either cooked in your van or enjoyed in Boschendal’s farm restaurant.",
        "passions": [
          "golf",
          "dining"
        ],
        "lodging": "camper"
      },
      {
        "day": "10, 11, 12",
        "name": "Cape Town Hotel & Table Mountain",
        "drive": "🚐 Drive time: ~1 hour",
        "start": "Pearl Valley Golf",
        "end": "Cape Town Hotel & Table Mountain",
        "text": "Drive into Cape Town to return your campervan. Check into your hotel for two nights to relax and explore. Spend the afternoon riding the cable car up Table Mountain for panoramic views or visiting the colorful houses of Bo-Kaap. The following day, discover the V&A Waterfront, Kirstenbosch Botanical Garden, or take a day trip to Cape Point.",
        "lodging": "hotel",
        "passions": []
      }
    ],
    "experiences": []
  },
  {
    "id": "hokkaido-powder-escape-campervan-ski-adventure",
    "title": "Hokkaido Powder Escape: Campervan Ski Adventure",
    "passions": [],
    "pick_up_country": "",
    "pick_up_location": "",
    "route_source": "Shopify export",
    "status": "complete",
    "provenance": "hand curated",
    "days_total": null,
    "distance_km": null,
    "toy": null,
    "days": [
      {
        "day": 1,
        "name": "Arrival in Sapporo",
        "drive": "🚐 Drive time: ~2 hrs",
        "start": "",
        "end": "Arrival in Sapporo",
        "text": "Pick up your 4WD camper in Sapporo. Stock up on essentials and make the scenic drive west through snowy farmland and forested hills. Spend the night near Niseko, the powder capital of Hokkaido.",
        "passions": [],
        "lodging": "camper"
      },
      {
        "day": 2,
        "name": "3 – Niseko United",
        "drive": "🚐 Drive time: 0 hrs (stay put)",
        "start": "Arrival in Sapporo",
        "end": "3 – Niseko United",
        "text": "Spend two full days skiing the four interlinked resorts of Niseko United. With over 2,100 acres (850 hectares) of skiable terrain and 30+ lifts, Niseko is famed for its deep powder, beautiful tree runs, and a fun, international ski town atmosphere. Enjoy après-ski ramen, soak in onsens like Yukichichibu, and sleep minutes from the lifts.",
        "passions": [],
        "lodging": "camper"
      },
      {
        "day": 4,
        "name": "5 – Rusutsu",
        "drive": "🚐 Drive time: ~1.5 hrs",
        "start": "3 – Niseko United",
        "end": "5 – Rusutsu",
        "text": "Drive over to Rusutsu, a quiet giant with big terrain and small crowds. The resort features 3 interconnected mountains, over 35 runs, and excellent tree skiing. Ski long, flowing runs through pillowy trees, and enjoy evening access to a quirky indoor amusement area. Great snow and fewer skiers make this a two-day highlight for both thrill seekers and nature lovers.",
        "passions": [],
        "lodging": "camper"
      },
      {
        "day": 6,
        "name": "7 – Asahidake",
        "drive": "🚐 Drive time: ~3.5 hrs",
        "start": "5 – Rusutsu",
        "end": "7 – Asahidake",
        "text": "Head north to Asahidake for two epic days of ropeway-access powder skiing. There are no groomed runs here—just lift-served backcountry on the flanks of an active volcano. The single ropeway brings skiers up to 1,600 m, offering open powder fields and dramatic scenery. Stay in a quiet onsen village where steaming baths greet you after long days on the mountain.",
        "passions": [],
        "lodging": "camper"
      },
      {
        "day": 8,
        "name": "Furano & Return to Sapporo",
        "drive": "🚐 Drive time: ~2.5 hrs to Furano, then ~2.5 hrs to Sapporo",
        "start": "7 – Asahidake",
        "end": "Furano & Return to Sapporo",
        "text": "Spend your final ski morning at Furano for one last taste of fast lifts, scenic runs, and excellent grooming. The resort boasts over 25 km of slopes and two main areas connected by lift. After lunch in town or one last soak in the Highland onsen, make your way back to Sapporo to return your van and toast the trip.",
        "passions": [],
        "lodging": "camper"
      }
    ]
  },
  {
    "id": "ireland-s-wild-west-fairways-by-campervan",
    "title": "Scenery, Culture & Iconic Golf: Ireland’s Wild Atlantic Links by Campervan",
    "passions": [
      "golf",
      "scenery",
      "culture",
      "whiskey",
      "hiking"
    ],
    "pick_up_country": "",
    "pick_up_location": "",
    "route_source": "Shopify export",
    "status": "complete",
    "provenance": "hand curated",
    "days_total": "8-14",
    "distance_km": null,
    "toy": null,
    "days": [
      {
        "day": 1,
        "name": "Arrival in Dublin & Clifden",
        "drive": "🚐 Drive time: ~3.5 hrs",
        "start": "",
        "end": "Arrival in Dubliny & Clifden",
        "text": "Collect your campervan and drive west to Clifden, gateway to Connemara. Stroll colourful streets lined with music-filled pubs, browse artisan shops, and enjoy a cosy dinner by an open fire.",
        "passions": [],
        "lodging": "camper"
      },
      {
        "day": 2,
        "name": "⛳ Connemara Championship Links",
        "drive": "🚐 Drive time: minimal",
        "start": "Arrival in Dubliny & Clifden",
        "end": "⛳ Connemara Championship Links",
        "text": "Play 18 unforgettable holes at this remote links course, where rugged dunes meet the Atlantic. In the afternoon, hike in Connemara National Park or relax by the harbour.",
        "passions": [
          "golf",
          "hiking"
        ],
        "lodging": "camper"
      },
      {
        "day": 3,
        "name": "Coastal Touring & Lahinch",
        "drive": "🚐 Drive time: ~3 hrs",
        "start": "⛳ Connemara Championship Links",
        "end": "Coastal Touring & Lahinch",
        "text": "Follow the Wild Atlantic Way south, stopping at Kylemore Abbey’s gothic beauty. Pause in the Burren’s limestone landscape before arriving in Lahinch.",
        "passions": [],
        "lodging": "camper"
      },
      {
        "day": 4,
        "name": "⛳ Lahinch Golf Club",
        "drive": "🚐 Drive time: minimal",
        "start": "Coastal Touring & Lahinch",
        "end": "⛳ Lahinch Golf Club",
        "text": "Tee off on this storied links, famous for natural dunes and unpredictable winds. After your round, walk the beach or visit the Cliffs of Moher.",
        "passions": [
          "golf",
          "scenery",
          "hiking"
        ],
        "lodging": "camper"
      },
      {
        "day": 5,
        "name": "Cliffs of Moher & Dingle Peninsula",
        "drive": "🚐 Drive time: ~2 hrs",
        "start": "⛳ Lahinch Golf Club",
        "end": "Cliffs of Moher & Dingle Peninsula",
        "text": "Spend the morning atop the cliffs, then drive to Dingle. Enjoy traditional music and fresh seafood in this famously friendly town.",
        "passions": [
          "scenery"
        ],
        "lodging": "camper"
      },
      {
        "day": 6,
        "name": "Ballybunion Arrival",
        "drive": "🚐 Drive time: ~1.5 hrs",
        "start": "Cliffs of Moher & Dingle Peninsula",
        "end": "Ballybunion Arrival",
        "text": "Drive south to Ballybunion. Stroll the towering sand dunes and settle into a campsite with sea views.",
        "passions": [
          "scenery"
        ],
        "lodging": "camper"
      },
      {
        "day": 7,
        "name": "⛳ Ballybunion Golf Club",
        "drive": "🚐 Drive time: minimal",
        "start": "Ballybunion Arrival",
        "end": "⛳ Ballybunion Golf Club",
        "text": "Play one of the world’s most revered links courses, soaking up views from elevated tees. Celebrate with a pint overlooking the Atlantic.",
        "passions": [
          "golf",
          "scenery"
        ],
        "lodging": "camper"
      },
      {
        "day": 8,
        "name": "⛳  Dooks Golf Club & Ring of Kerry",
        "drive": "🚐 Drive time: ~1 hr",
        "start": "⛳ Ballybunion Golf Club",
        "end": "⛳ Dooks Golf Club & Ring",
        "text": "Drive to Dooks for a more relaxed round. This hidden gem offers sweeping views across Dingle Bay. Camp overnight by arrangement.",
        "passions": [
          "scenery"
        ],
        "lodging": "camper"
      },
      {
        "day": 9,
        "name": "Ring of Kerry Touring & ⛳  Beerhaven Golf",
        "drive": "🚐 Drive time: ~1–2 hrs",
        "start": "⛳ Dooks Golf Club & Ring",
        "end": "Ring of Kerry Touring & ⛳",
        "text": "Explore the Ring of Kerry’s dramatic loop—ancient stone forts, hidden beaches, and mountain passes await. Option to play and stay at Beerhaven golf club where you can camp onsite and play with views towards Bere island.",
        "passions": [
          "golf",
          "scenery"
        ],
        "lodging": "camper"
      },
      {
        "day": 10,
        "name": "Return to Dublin",
        "drive": "🚐 Drive time: ~4 hrs",
        "start": "Ring of Kerry Touring & ⛳",
        "end": "Dublin",
        "text": "Return your campervan and head home.",
        "passions": [],
        "lodging": "camper"
      }
    ],
    "start": "Dublin",
    "end": "Clifden"
  },
  {
    "id": "italy-wonders-guided-tour-2024-date-tbc",
    "title": "Italy Wonders Guided Campervan Tour (2026 date TBC)",
    "passions": [],
    "pick_up_country": "coming soon",
    "pick_up_location": "coming soon",
    "route_source": "Shopify export",
    "status": "coming soon",
    "provenance": "hand curated",
    "days_total": "coming soon",
    "distance_km": "coming soon",
    "toy": null,
    "days": []
  },
  {
    "id": "norway-fjords-peaks-craft-with-tromso-midnight-sun-race-bergen-international-festival",
    "title": "Norway Fjords, Peaks & Craft with Tromso Midnight Sun Race & Bergen International Festival",
    "passions": [
      "running",
      "crafts",
      "scenery",
      "saunas",
      "hiking",
      "festivals"
    ],
    "pick_up_country": "coming soon",
    "pick_up_location": "coming soon",
    "route_source": "Shopify export",
    "status": "coming soon",
    "provenance": "hand curated",
    "days_total": 17,
    "distance_km": 2024,
    "toy": null,
    "days": []
  },
  {
    "id": "norway-fjords-trolltunga-adventure",
    "title": "Trolltunga Via Ferata, Norway Fjords + Bergen Food & Cider Festival",
    "passions": [],
    "pick_up_country": "",
    "pick_up_location": "",
    "route_source": "Shopify export",
    "status": "complete",
    "provenance": "hand curated",
    "days_total": null,
    "distance_km": null,
    "toy": null,
    "days": [
      {
        "day": 1,
        "name": "Friday 5 Sept – Bergen Arrival (Hotel Stay)",
        "drive": "",
        "start": "",
        "end": "Friday 5 Sept – Bergen Arrival",
        "text": "Fly Amsterdam → Bergen (Arrive 10:00). Check into a hotel for your first night. In the afternoon, head into the Bergen Food & Cider Festival, where Hardanger cider, cheeses, and local dishes are served up in lively squares across the city. Since the festival fills most of the afternoon and evening, you may choose either to explore the historic Bryggen Wharf with its colourful timber warehouses, or to take the Fløibanen funicular up Mount Fløyen for forest trails and city views. Both are close to the centre, but you’ll likely only have time for one before immersing yourself in the festival atmosphere.\nDrive: none",
        "passions": [],
        "lodging": "hotel"
      },
      {
        "day": 2,
        "name": "Saturday 6 Sept – Bergen → Tvindefossen → Nærøyfjorden Camping",
        "drive": "",
        "start": "Friday 5 Sept – Bergen Arrival",
        "end": "Saturday 6 Sept – Bergen →",
        "text": "Pick up your campervan at 11:00 (depart ~12:30). Drive east via Voss, pausing at Tvindefossen waterfall, a spectacular 110m cascade where fine ribbons of water drop over a wide cliff face. Continue through the valley into Gudvangen, arriving at Nærøyfjorden Camping by late afternoon. With pitches directly on the fjord edge, you can settle in and, if time allows, enjoy a sauna session or rent a kayak/SUP for a short paddle before dinner. Otherwise, simply relax at your van with the fjord views unfolding around you.\nDrive: ~150 km / 3 hrs",
        "passions": [],
        "lodging": "camper"
      },
      {
        "day": 3,
        "name": "Sunday 7 Sept – Nærøyfjord → Aurlandsfjellet Wild Camp",
        "drive": "",
        "start": "Saturday 6 Sept – Bergen →",
        "end": "Sunday 7 Sept – Nærøyfjord →",
        "text": "Begin the day with a relaxed breakfast by the fjord or an early paddle, then drive via Flåm and start climbing the Aurlandsfjellet Scenic Route. Known as the “Snow Road”, this high mountain pass runs from Aurland to Lærdal, crossing tundra landscapes dotted with small lakes and often with patches of snow still visible in September. Stop at the dramatic Stegastein Viewpoint, a glass platform 650m above Aurlandfjord, before continuing into the high plateau. Along the road, several marked trails allow for short hikes directly from the roadside, giving you the chance to experience quiet mountain landscapes on foot. Wild camp at a pull-off on the plateau, where the evening brings stillness, big skies, and a sense of complete escape.\nDrive: ~70 km / 2 hrs",
        "passions": [],
        "lodging": "camper"
      },
      {
        "day": 4,
        "name": "Monday 8 Sept – Aurland → Hardangerfjord (Lofthus Camping)",
        "drive": "",
        "start": "Sunday 7 Sept – Nærøyfjord →",
        "end": "Monday 8 Sept – Aurland →",
        "text": "Descend from the mountains into Sørfjorden, part of the Hardangerfjord. The drive brings you past waterfalls, orchards, and the sight of the Folgefonna glacier in the distance. Arrive at Lofthus Camping, a terraced site overlooking the fjord. In the afternoon, swim in the clear waters, visit a cider farm for a tasting, or book a private wood-fired sauna with direct fjord access. Early September is apple harvest season in Hardanger, and the orchards create a unique atmosphere along the fjord edge.\nDrive: ~180 km / 3.5 hrs",
        "passions": [],
        "lodging": "camper"
      },
      {
        "day": 5,
        "name": "Tuesday 9 Sept – Trolltunga via ferrata → Wild Camp on route back to Bergen",
        "drive": "",
        "start": "Monday 8 Sept – Aurland →",
        "end": "Tuesday 9 Sept – Trolltunga via",
        "text": "Rise early and meet your guide in Tyssedal at 07:30 for the Trolltunga via ferrata. This demanding but exhilarating day (8–12 hrs) combines cable car ascent, steel ladders, and cliffside cables to traverse ridges high above Ringedalsvatnet lake. The reward is reaching Trolltunga itself — a rock ledge jutting 700m above the fjord — one of Norway’s most iconic views. After returning from the hike and collecting your gear, start your journey back towards Bergen and pick a wild camping spot, where you can rest after your long day on the mountain.\nDrive: ~40 km / 45 mins",
        "passions": [],
        "lodging": "camper"
      },
      {
        "day": 6,
        "name": "Wednesday 10 Sept – Bergen (Return)",
        "drive": "",
        "start": "Tuesday 9 Sept – Trolltunga via",
        "end": "Wednesday 10 Sept – Bergen (Return)",
        "text": "After breakfast, begin the drive back to Bergen. The journey takes about three hours, but you’ll have time to add a stop or two along the way: perhaps Låtefossen waterfall, where twin streams crash beneath an arched bridge; Steinsdalsfossen, a rare waterfall you can walk behind; or the Hardanger Folk Museum in Utne, which offers insight into the region’s culture and traditions. Return the campervan in Bergen by 15:00, then head to the airport for your 17:45 flight to Amsterdam.\nDrive: ~170 km / 2.5 hrs",
        "passions": [],
        "lodging": "camper"
      }
    ]
  },
  {
    "id": "norwegian-fjords-pulpit-rock-a-self-guided-running-adventure",
    "title": "Norwegian Fjords & Pulpit Rock: A Long Weekend Running Trip",
    "passions": [
      "hiking",
      "scenery",
      "saunas",
      "nature"
    ],
    "pick_up_country": "",
    "pick_up_location": "",
    "route_source": "Shopify export",
    "status": "complete",
    "provenance": "hand curated",
    "days_total": null,
    "distance_km": null,
    "toy": null,
    "days": [
      {
        "day": 1,
        "name": "Pick Up in Bergen & Drive to Hardangerfjord",
        "drive": "🚐 Drive time: ~2.5 hours.",
        "start": "",
        "end": "Pick Up in Bergen & Drive",
        "text": "Arrive in Bergen and collect your campervan. Stock up on supplies, then set out along the scenic Hardangerfjord route. Drive past waterfalls and fruit orchards to a quiet campsite near the fjord's edge. Settle in with a campfire meal and take in the evening light over the water.\n\n🗓️",
        "passions": [
          "scenery"
        ],
        "lodging": "camper"
      },
      {
        "day": 2,
        "name": "Morning Fjord Run & Drive to Preikestolen Base",
        "drive": "🚐 Drive time: ~4 hours (including ferry).",
        "start": "Pick Up in Bergen & Drive",
        "end": "Morning Fjord Run & Drive to",
        "text": "🏃 Suggested run distance: 4–8 km\nStart the day with a tranquil run on forested trails along the fjord, where the morning mist hangs low over the still water. After breakfast, begin your drive south toward Lysefjord. Take the ferry at Hjelmeland and continue to the base of Preikestolen (Pulpit Rock). Camp nearby, ready for the big climb.\n\n🗓️",
        "passions": [
          "hiking",
          "scenery",
          "nature"
        ],
        "lodging": "camper"
      },
      {
        "day": 3,
        "name": "Sunrise Run to Preikestolen & Scenic Return Toward Bergen",
        "drive": "🚐 Drive time: ~3.5 hours.",
        "start": "Morning Fjord Run & Drive to",
        "end": "Sunrise Run to Preikestolen & Scenic",
        "text": "🏃 Suggested run distance: 8 km (out-and-back hike/run)\nWake early and ascend to Preikestolen before the crowds. At the top, catch your breath with jaw-dropping views over Lysefjord. Descend mid-morning and begin your scenic return drive north. Stop en route at a lakeside wild camp or forest campground to unwind.\n\n🗓️",
        "passions": [
          "hiking",
          "scenery",
          "nature"
        ],
        "lodging": "camper"
      },
      {
        "day": 4,
        "name": "Waterfall Run & Return to Bergen",
        "drive": "🚐 Drive time: ~2.5 hours.",
        "start": "Sunrise Run to Preikestolen & Scenic",
        "end": "Waterfall Run & Return to Bergen",
        "text": "🏃 Suggested run distance: 3–5 km\nEase into the final morning with a short run near Steinsdalsfossen or Låtefossen—both offer stunning trails beside roaring cascades. Then drive back to Bergen and return your campervan. Enjoy a celebratory lunch in the historic Bryggen district before heading home.",
        "passions": [
          "hiking"
        ],
        "lodging": "camper"
      }
    ]
  },
  {
    "id": "route-delft-naarden-amersfoort-zutphen-amsterdam-city-culture",
    "title": "Explore Delft to Amsterdam: Culture, Veluwe & Canals",
    "passions": [
      "culture",
      "art",
      "history",
      "hiking"
    ],
    "pick_up_country": "",
    "pick_up_location": "",
    "route_source": "Shopify export",
    "status": "complete",
    "provenance": "local expert",
    "days_total": 9,
    "distance_km": 400,
    "toy": null,
    "days": [
      {
        "day": 1,
        "name": "Delft: Canals, Ceramics & Vermeer",
        "drive": "🚐 Drive time: ~1 h from Amsterdam Schiphol",
        "start": "",
        "end": "Delft: Canals, Ceramics & Vermeer",
        "text": "Arrive in Delft, the city of painters and pottery. Explore the Markt square, Vermeer Centrum, and a Delftware studio where artisans hand-paint blue ceramics. End the day with an evening walk beside tree-lined canals.",
        "passions": [
          "culture",
          "hiking"
        ],
        "lodging": "camper"
      },
      {
        "day": 2,
        "name": "Naarden Vesting: Star-Fortress Strolls",
        "drive": "🚐 Drive time: ~45 min from Delft",
        "start": "Delft: Canals, Ceramics & Vermeer",
        "end": "Naarden Vesting: Star-Fortress Strolls",
        "text": "Travel to Naarden, a perfectly preserved star-shaped fortress town. Walk the ramparts, cross drawbridges, and visit the underground casemates of the Vestingmuseum. Cafés inside the walls make a great lunch stop.",
        "passions": [
          "culture",
          "history",
          "hiking"
        ],
        "lodging": "camper"
      },
      {
        "day": 3,
        "name": "Amersfoort: Medieval Gates & Terraces",
        "drive": "🚐 Drive time: ~35 min from Naarden",
        "start": "Naarden Vesting: Star-Fortress Strolls",
        "end": "Amersfoort: Medieval Gates & Terraces",
        "text": "Discover Amersfoort’s photogenic Koppelpoort gate, winding streets, and hidden courtyards. Browse small museums, pause at canal-side terraces, and enjoy the compact, lively feel of this medieval town.",
        "passions": [
          "culture",
          "history"
        ],
        "lodging": "camper"
      },
      {
        "day": 4,
        "name": "Veluwe Forests & Campsite Stay",
        "drive": "🚐 Drive time: ~1 h from Amersfoort",
        "start": "Amersfoort: Medieval Gates & Terraces",
        "end": "Veluwe Forests & Campsite Stay",
        "text": "Head into the Veluwe, a landscape of rolling heathland, pine woods, and shifting sands. Set up camp at a forest campsite and hike quiet trails where red deer and wild boar roam. Sleeping under the trees is a highlight of the trip.",
        "passions": [
          "hiking"
        ],
        "lodging": "camper"
      },
      {
        "day": 5,
        "name": "Kröller-Müller Museum & More Veluwe Trails",
        "drive": "🚐 Drive time: ~30–45 min within the park",
        "start": "Veluwe Forests & Campsite Stay",
        "end": "Kröller-Müller Museum & More Veluwe Trails",
        "text": "Use the park’s free white bikes to explore further. Visit the Kröller-Müller Museum to see one of the world’s best Van Gogh collections, along with an open-air sculpture garden. Spend the rest of the day walking or cycling across the park’s wide landscapes.",
        "passions": [
          "culture",
          "history",
          "hiking"
        ],
        "lodging": "camper"
      },
      {
        "day": 6,
        "name": "Zutphen: Hanseatic Heritage",
        "drive": "🚐 Drive time: ~1 h from Veluwe",
        "start": "Kröller-Müller Museum & More Veluwe Trails",
        "end": "Zutphen: Hanseatic Heritage",
        "text": "Zutphen charms with medieval towers, riverside views, and streets filled with bookshops and cafés. Spend the day exploring this historic Hanseatic city, with optional visits to its small museums or a guided walking tour.",
        "passions": [
          "culture",
          "history",
          "hiking"
        ],
        "lodging": "camper"
      },
      {
        "day": 7,
        "name": "Amsterdam: Museums & Canals",
        "drive": "🚐 Drive time: ~1 h 45 from Zutphen",
        "start": "Zutphen: Hanseatic Heritage",
        "end": "Amsterdam: Museums & Canals",
        "text": "Arrive in Amsterdam for a three-night finale. Choose between a campsite on the city edge or a comfortable hotel. Spend the afternoon visiting the Rijksmuseum or Van Gogh Museum, then enjoy a calm canal cruise past gabled houses. Evenings are perfect for relaxed dining in a traditional brasserie.",
        "passions": [
          "culture",
          "history"
        ],
        "lodging": "hotel"
      },
      {
        "day": 8,
        "name": "Amsterdam: Art, Gardens & Heritage",
        "drive": "🚐 Drive time: none",
        "start": "Amsterdam: Museums & Canals",
        "end": "Amsterdam: Art, Gardens & Heritage",
        "text": "Dedicate today to the city’s quieter treasures. Visit the Hermitage or Stedelijk for world-class art, stroll through the historic Begijnhof courtyard, or enjoy the greenery of Vondelpark and the Botanical Garden. A guided walking tour of the canal belt offers depth and context without rushing.",
        "passions": [
          "culture",
          "history",
          "hiking"
        ],
        "lodging": "camper"
      },
      {
        "day": 9,
        "name": "Amsterdam: Slow Finale & Departure",
        "drive": "🚐 Drive time: depends on return point",
        "start": "Amsterdam: Art, Gardens & Heritage",
        "end": "Amsterdam: Slow Finale & Departure",
        "text": "Savor your last morning with a canal-side breakfast and perhaps a stop at the Concertgebouw or one of the smaller house museums like the Willet-Holthuysen. Pick up final souvenirs before returning your camper or checking out of your hotel.",
        "passions": [
          "culture",
          "history"
        ],
        "lodging": "hotel"
      }
    ]
  },
  {
    "id": "route-the-wildest-golf-courses-in-the-world-kruger-national-park",
    "title": "Safari & Championship Greens: An Epic Kruger Golf Expedition",
    "passions": [
      "golf",
      "safari",
      "nature",
      "adventure",
      "wildlife"
    ],
    "pick_up_country": "South Africa",
    "pick_up_location": "",
    "route_source": "Shopify export",
    "status": "complete",
    "provenance": "local expert",
    "days_total": "8-12",
    "distance_km": 1375,
    "toy": null,
    "days": [
      {
        "day": 1,
        "name": "Collect Camper & Overnight near Leopard Creek",
        "drive": "🚐 Drive time: ~4.5 hours from Johannesburg",
        "start": "",
        "end": "Collect Camper & Overnight near Leopard",
        "text": "Pick up your safari-equipped campervan in Johannesburg and drive to Malelane. Stay just outside Kruger, perfectly positioned for a morning tee time at Leopard Creek.",
        "passions": [
          "golf",
          "safari"
        ],
        "lodging": "camper",
        "experiences": [
          
        ]
      },
      {
        "day": 2,
        "name": "Leopard Creek Golf & Lower Sabie Rest Camp",
        "drive": "🚐 Drive time: ~2 hours inside the park",
        "start": "Collect Camper & Overnight near Leopard",
        "end": "Leopard Creek Golf & Lower Sabie",
        "text": "Enjoy an early morning round at Leopard Creek Country Club, a world-famous Gary Player design combining immaculate conditioning, elevated tees, and challenging holes hugging the Crocodile River—where you may see hippos or elephants while you play. After golf, enter Kruger via Malelane Gate and drive through mixed woodland and riverine forests. Lookout points like Matjulu and Renosterkoppies provide perfect stops to spot rhino and giraffes. Continue toward Lower Sabie, watching for elephants crossing the road and herds of buffalo grazing along the river.",
        "passions": [
          "golf",
          "safari",
          "nature",
          "wildlife"
        ],
        "lodging": "camper"
      },
      {
        "day": 3,
        "name": "Skukuza & Optional Golf",
        "drive": "🚐 Drive time: ~45 minutes",
        "start": "Leopard Creek Golf & Lower Sabie",
        "end": "Skukuza & Optional Golf",
        "text": "Morning game drive as you head along the Sabie River, renowned for its concentrations of wildlife, including leopards resting in trees, elephants in the shallows, and hippos basking on sandbanks. Arrive at Skukuza for check-in and an optional round on the bushveld 9-hole Skukuza Golf Course, a gently undulating course lined with indigenous trees and small, challenging greens. The experience of playing here is special because of the chance encounters with impala and warthog wandering across your fairway, and the atmosphere of golfing in the wild.",
        "passions": [
          "golf",
          "safari",
          "nature",
          "adventure",
          "wildlife"
        ],
        "lodging": "camper",
        "experiences": [
          "wildest-golf-courses-kruger-south-africa"
        ]
      },
      {
        "day": 4,
        "name": "Morning Golf & Lion Sands River Lodge",
        "drive": "🚐 Drive time: ~2 hours",
        "start": "Skukuza & Optional Golf",
        "end": "Morning Golf & Lion Sands River",
        "text": "Early morning golf at Skukuza before driving through savanna landscapes rich with giraffe, kudu, and zebra. Pause at Nkuhlu Picnic Site to take in views of the Sabie River and possibly spot crocodiles and hippos. Continue to Lion Sands River Lodge to enjoy a luxury stay and sunset guided drives in Big Five country. Option for a sunset guided game drive or to simply relax in the tranquility of this magnificent lodge.",
        "passions": [
          "golf",
          "safari",
          "nature",
          "wildlife"
        ],
        "lodging": "camper"
      },
      {
        "day": 5,
        "name": "Lion Sands",
        "drive": "🚐 Drive time: none",
        "start": "Morning Golf & Lion Sands River",
        "end": "Lion Sands",
        "text": "Dawn game drive in an open jeep hosted by your safari guide, taking you close to the Big Five and offering exceptional photographic opportunities. Spend the afternoon relaxing by the pool or enjoying fine dining overlooking the river. You may also choose additional activities such as guided bush walks, birdwatching, or a sunset drive to see nocturnal predators becoming active.",
        "passions": [
          "safari",
          "nature",
          "adventure"
        ],
        "lodging": "camper"
      },
      {
        "day": 6,
        "name": "Olifants Rest Camp",
        "drive": "🚐 Drive time: ~4 hours",
        "start": "Lion Sands",
        "end": "Olifants Rest Camp",
        "text": "Depart Lion Sands and re-enter Kruger through Orpen Gate, heading north through open savanna and mopane woodland. This part of Kruger is known for large elephant bulls and expansive views across the Olifants River valley. Arrive at Olifants Rest Camp, perched high above the river where you can watch herds gathering below.",
        "passions": [
          "safari",
          "nature",
          "wildlife"
        ],
        "lodging": "camper"
      },
      {
        "day": 7,
        "name": "Drive to Hans Merensky / Ba-Phalaborwa Golf",
        "drive": "🚐 Drive time: ~1 hour",
        "start": "Olifants Rest Camp",
        "end": "Hans Merensky / Ba-Phalaborwa Golf",
        "text": "Enjoy your last wildlife sightings as you exit Kruger and travel to Ba-Phalaborwa Golf Course. This course is renowned for broad kikuyu fairways, raised greens framed by bushveld trees, and water hazards that hippos and crocodiles often share. Every hole offers a blend of golfing challenge and safari atmosphere.",
        "passions": [
          "golf",
          "safari",
          "wildlife"
        ],
        "lodging": "camper",
        "experiences": [
          
        ]
      },
      {
        "day": 8,
        "name": "Morning Golf & Drive to Panorama Route",
        "drive": "🚐 Drive time: ~2.5 hours",
        "start": "Hans Merensky / Ba-Phalaborwa Golf",
        "end": "Morning Golf & Drive to Panorama",
        "text": "Play a morning round at Ba-Phalaborwa Golf Course before setting out on the Panorama Route. Along this route, expect breathtaking vistas of rugged cliffs, cascading waterfalls, and forested ravines. Highlights include God’s Window, where you can gaze across an endless sweep of green Lowveld plains.🚐 Drive time: ~2.5 hours",
        "passions": [
          "golf",
          "nature"
        ],
        "lodging": "camper"
      },
      {
        "day": 9,
        "name": "Panorama Route & Return to Johannesburg",
        "drive": "🚐 Drive time: ~5 hours",
        "start": "Morning Golf & Drive to Panorama",
        "end": "Panorama Route & Return to Johannesburg",
        "text": "Begin your day with sunrise views over Blyde River Canyon, one of Africa’s most impressive landscapes, before driving back to Johannesburg to return your campervan.",
        "passions": [
          "nature"
        ],
        "lodging": "camper"
      }
    ]
  },
  {
    "id": "run-greece-ancient-sites-clifftop-trails-olympic-stadium-run-by-camper",
    "title": "Run Greece: Ancient sites, Clifftop trails & Olympic Stadium Run by Camper",
    "passions": [
      "running",
      "beach",
      "scenery",
      "history",
      "culture",
      "night-life"
    ],
    "pick_up_country": "",
    "pick_up_location": "",
    "route_source": "Shopify export",
    "status": "complete",
    "provenance": "hand curated",
    "days_total": 8,
    "distance_km": 1290,
    "toy": null,
    "days": [
      {
        "day": 1,
        "name": "Arrive in Athens & Drive to Camping",
        "drive": "🚐 Drive time: ~2.5 hours",
        "start": "",
        "end": "Athens & Drive to Camping",
        "text": "Pick up your campervan and head west to a peaceful coastal campsite perfect for your first night in Greece. This relaxed spot lets you ease into the journey, with a swim in the clear water and dinner by the sea.\n\n🗓️",
        "passions": [
          "beach"
        ],
        "lodging": "camper"
      },
      {
        "day": 2,
        "name": "Drive & Ferry to Corfu",
        "drive": "🚐 Drive time: ~3 hours + ferry",
        "start": "Athens & Drive to Camping",
        "end": "Drive & Ferry to Corfu",
        "text": "Depart Camping Tsolis and drive north to Igoumenitsa. Take the ferry across to Corfu and settle into a top-rated beachfront campsite known for its wide sandy shore and excellent facilities.\n\n🗓️",
        "passions": [
          "beach"
        ],
        "lodging": "camper"
      },
      {
        "day": 3,
        "name": "Cliff-top Trail &run Corfu Old Town",
        "drive": "🚐 Drive time: ~1-2 hours depending on choice of activities on Corfu",
        "start": "Drive & Ferry to Corfu",
        "end": "Cliff-top Trail &run Corfu Old Town",
        "text": "Begin the day with a cliff-top morning trail run, where narrow paths lead to stunning cliff viewpoints and turquoise coves. This is one of Corfu’s most photographed spots, and the run here is both scenic and peaceful. In the evening, explore Corfu Old Town’s cobblestone lanes, Venetian architecture, and lively tavernas.\n🏃‍♂️Suggested run: 8.85km, 140m elevation\n\n🗓️",
        "passions": [
          "running",
          "scenery",
          "culture"
        ],
        "lodging": "camper"
      },
      {
        "day": 4,
        "name": "Return to Mainland & Vikos Gorge (Option to extend stay in Corfu)",
        "drive": "🚐 Drive time: ~5 hours including ferry",
        "start": "Cliff-top Trail &run Corfu Old Town",
        "end": "Mainland & Vikos Gorge (Option to",
        "text": "Given the beauty of Corfu, the excellent campsite, and the many great things to do on the island, you may wish to stay longer before continuing, alternatively...\nTake the early morning ferry back to the mainland. Drive to the Zagori region, stopping to see the remarkable Stone Forest rock formations, beautiful Vikos Gorge viewpoints, and centuries-old monasteries. Vikos Gorge is listed by Guinness World Records as the deepest gorge in the world relative to its width, with cliffs over 1,000 meters high plunging into a narrow canyon floor.\n\n🗓️",
        "passions": [
          "scenery"
        ],
        "lodging": "camper"
      },
      {
        "day": 5,
        "name": "Zagori Run & Drive to Meteora",
        "drive": "🚐 Drive time: ~3 hours",
        "start": "Mainland & Vikos Gorge (Option to",
        "end": "Zagori Run & Drive to Meteora",
        "text": "Begin the day with a trail run through Zagori’s stone bridge network—arching footbridges from the 18th century that connect tiny mountain villages. The route winds through oak forest and over quiet rivers. Afterward, drive to Meteora a UNESCO World Heritage Site where ancient monasteries sit atop towering sandstone pillars rising dramatically from the valley floor, creating a landscape of awe-inspiring beauty and spiritual history. Spend the afternoon visiting the cliff-top monasteries before cooking dinner in your campervan overlooking the pinnacles and watching the sunset from the rocks.\n🏃‍♂️ Suggested run: 9.62km, 505m elevation\n\n🗓️",
        "passions": [
          "running",
          "scenery",
          "history",
          "culture"
        ],
        "lodging": "camper"
      },
      {
        "day": 6,
        "name": "Meteora Trail Circuit & Drive to Delphi",
        "drive": "🚐 Drive time: ~3 hours",
        "start": "Zagori Run & Drive to Meteora",
        "end": "Meteora Trail Circuit & Drive to",
        "text": "Early morning run along the Meteora trails. This area is a UNESCO site where giant rock towers rise from the plain, creating an unforgettable backdrop for your run. Later, drive south to Delphi and settle in for the night.\n🏃‍♂️ Suggested run: 10.02km, 428m elevation\n\n🗓️",
        "passions": [
          "running"
        ],
        "lodging": "camper"
      },
      {
        "day": 7,
        "name": "Delphi Visit, Drive to Athens & check-in to hotel",
        "drive": "🚐 Drive time: ~2.5 hours",
        "start": "Meteora Trail Circuit & Drive to",
        "end": "Delphi Visit, Drive to Athens &",
        "text": "Spend the morning exploring Delphi’s Sacred Way and the Sanctuary of Apollo. Delphi was once considered the centre of the ancient world, where the Oracle of Apollo delivered prophecies believed to shape the fate of empires. At the top of the site, you’ll find the ancient stadium, once used for athletic competitions as part of the Pythian Games—its stone seating and starting lines still visible. Later, drive to Athens, return your campervan, and check in to your hotel. In the evening, enjoy a cocktail from one of Athens’ fantastic rooftop bars with views over the illuminated Acropolis.\n\n🗓️",
        "passions": [
          "beach",
          "scenery",
          "history"
        ],
        "lodging": "hotel"
      },
      {
        "day": 8,
        "name": "Athens Olympic Stadium Run & Departure",
        "drive": "",
        "start": "Delphi Visit, Drive to Athens &",
        "end": "Athens Olympic Stadium Run & Departure",
        "text": "Start your morning with a final run around the Panathenaic Stadium—built entirely of marble and the site of the first modern Olympic Games in 1896. The stadium is open to the public for jogging sessions, so you can experience running on this historic track. Finish your trip by exploring Athens highlights such as the Acropolis before taking your evening flight home, or extend your journey to experience more of Greece’s wonders, including the beautiful Cyclades islands.\n🏃‍♂️ Suggested run: 1500m, 0m elevation",
        "passions": [
          "running",
          "history",
          "culture"
        ],
        "lodging": "camper"
      }
    ]
  },
  {
    "id": "run-hike-joburg-to-cape-town",
    "title": "Run & Hike from Jo'burg to Cape Town: Big Skies, Passes & Ocean Trails",
    "passions": [
      "running",
      "trail-running",
      "nature",
      "mountains",
      "coast",
      "adventure"
    ],
    "pick_up_country": "South Africa",
    "pick_up_location": "Johannesburg",
    "route_source": "Shopify export",
    "status": "coming soon",
    "provenance": "local expert",
    "days_total": "10-14",
    "distance_km": "1600-1800",
    "toy": null,
    "days": []
  },
  {
    "id": "run-sweden",
    "title": "Sweden Forest Running Adventure: 3 Top Strava Routes by Camper",
    "passions": [
      "forest",
      "nature",
      "saunas",
      "scenery",
      "off-grid"
    ],
    "pick_up_country": "coming soon",
    "pick_up_location": "coming soon",
    "route_source": "Shopify export",
    "status": "coming soon",
    "provenance": "hand curated",
    "days_total": "coming soon",
    "distance_km": "coming soon",
    "toy": null,
    "days": []
  },
  {
    "id": "run-tromso-midnight-marathon-lofotens-lyngen",
    "title": "Run Tromsø Midnight Marathon, Half or Copa Mila + Lofoten Islands",
    "passions": [
      "running",
      "adventure",
      "nature",
      "photography"
    ],
    "pick_up_country": "",
    "pick_up_location": "",
    "route_source": "Shopify export",
    "status": "complete",
    "provenance": "hand curated",
    "days_total": 8,
    "distance_km": 900,
    "toy": null,
    "days": [
      {
        "day": 1,
        "name": "Arrive in Tromsø & Drive South",
        "text": "Collect your campervan, stock up on groceries and running fuel, then head south through island scenery where reindeer graze by the roadside. Cross sweeping bridges between fjords before settling beside a quiet lake near Bjerkvik or Evenes for your first Arctic night.\n🚐 Drive ≈ 180 km · 3 hrs\n\n🏃‍♂️ Suggested run: 5 km easy shake-out along the shoreline",
        "passions": [
          "running",
          "nature"
        ],
        "lodging": "camper"
      },
      {
        "day": 2,
        "name": "Into the Lofoten Islands",
        "text": "Follow the E10 coastal road — one of Europe’s most breathtaking drives. Stop in Henningsvær for coffee and a lighthouse-trail jog with sea views. Continue to Svolvær, framed by granite spires glowing gold at midnight.\n🚐 Drive ≈ 240 km · 4 hrs\n\n🏃‍♂️ Suggested run: 6 km loop · Henningsvær Lighthouse Trail",
        "passions": [
          "running"
        ],
        "lodging": "camper"
      },
      {
        "day": 3,
        "name": "Run to Kvalvika Beach & Explore Reine",
        "text": "Early start for the iconic Kvalvika Beach trail, a climb to a hidden turquoise bay surrounded by cliffs. Picnic in the sand, then wander Reine’s wooden piers or paddle a kayak between islets glowing in the low Arctic sun.\n🚐 Drive ≈ 60 km · 1 hr\n\n🏃‍♂️ Suggested run: 10 km return · Kvalvika Beach Trail",
        "passions": [
          "running",
          "adventure"
        ],
        "lodging": "camper"
      },
      {
        "day": 4,
        "name": "North Lofoten & White-Sand Beaches",
        "text": "Run the coastal path at Eggum and picnic on Uttakleiv Beach, where emerald waves meet green slopes. Afternoon swim or photography stop before camping near the open Atlantic, eagles circling overhead.\n🚐 Drive ≈ 120 km · 2 hrs\n\n🏃‍♂️ Suggested run: 8 km loop · Eggum Coastal Path",
        "passions": [
          "running"
        ],
        "lodging": "camper"
      },
      {
        "day": 5,
        "name": "Lofoten to Lyngen Alps (Adjustable Weather Day)",
        "text": "Set out east through tundra valleys and mirror-flat lakes. Pause in Narvik for lunch over Ofotfjord, then follow fjords and birch forest to the Lyngen Peninsula. Depending on weather, you can shift this drive a day earlier or later to catch clear skies for mountain views. Arrive near Lyngseidet for an evening stroll by the water.\n🚐 Drive ≈ 350 km · 6 hrs\n\n🏃‍♂️ Suggested run: Rest or optional 5 km recovery along Lyngseidet shore",
        "passions": [
          "running",
          "adventure",
          "nature"
        ],
        "lodging": "camper"
      },
      {
        "day": 6,
        "name": "Lyngen Trails & Fjord Views (Pre-Race Shake-Out)",
        "text": "A relaxed morning with a short “shake-out” jog toward Lyngstuva Lighthouse — where sea and sky blend in pale light. Afternoon sauna, glacier viewpoints or berry-farm visits. Let the body rest while the mind soaks in Arctic calm.\n🚐 Drive ≈ 60 km · 1 hr\n\n🏃‍♂️ Suggested run: 3 km easy · Lyngstuva Lighthouse Path",
        "passions": [
          "running"
        ],
        "lodging": "camper"
      },
      {
        "day": 7,
        "name": "Return to Tromsø & Pre-Race Prep",
        "text": "Drive back across the ferry route or E8 coast road, tracing islands and peaks reflected in glassy fjords. Arrive Tromsø late afternoon, park by the harbour, collect your race bib and enjoy the city’s festival buzz beneath the midnight sun.\n🚐 Drive ≈ 200 km · 4 hrs\n\n🏃‍♂️ Suggested run: Rest · gentle stretch by the water",
        "passions": [
          "running",
          "nature"
        ],
        "lodging": "camper"
      },
      {
        "day": 8,
        "name": "Midnight Sun Marathon 🏁",
        "text": "Morning at leisure — visit the Polar Museum or relax by the water. As night never falls, join runners from around the world for the Tromsø Midnight Sun Marathon, Half Marathon or Coop Mila 10 km. Run through glowing Arctic light, finish beside the fjord, medal in hand, and celebrate with live music and local beer before your final night’s sleep.\n🚐 Drive — minimal (local transfers only)\n\n🏃‍♂️ Race options: 42 km · 21 km · 10 km",
        "passions": [
          "running"
        ],
        "lodging": "camper"
      }
    ]
  },
  {
    "id": "scandi-wild-sweden-s-great-family-campervan-escape",
    "title": "Lakes, Forests & Freedom: Sweden’s Great Family Campervan Escape",
    "passions": [],
    "pick_up_country": "coming soon",
    "pick_up_location": "coming soon",
    "route_source": "Shopify export",
    "status": "coming soon",
    "provenance": "hand curated",
    "days_total": "coming soon",
    "distance_km": "coming soon",
    "toy": null,
    "days": []
  },
  {
    "id": "sedona-trail-running-campervan-tour",
    "title": "Trails of Arizona & Nevada on a Route 66 RV road trip",
    "passions": [
      "trail-running",
      "hiking",
      "nature"
    ],
    "pick_up_country": "",
    "pick_up_location": "",
    "route_source": "Shopify export",
    "status": "complete",
    "provenance": "hand curated",
    "days_total": 8,
    "distance_km": 1100,
    "toy": null,
    "days": [
      {
        "day": 1,
        "name": "Pick Up in Las Vegas & Valley of Fire State Park",
        "text": "Collect your campervan in Las Vegas (45 min drive). On arrival at Valley of Fire, take a short hike through fiery sandstone formations (Fire Wave, White Domes). Evenings can be cool in February — option to cook your first meal outside under the stars (campfires generally not permitted; propane stoves and charcoal grills are allowed) or inside the van.",
        "drive": "🚐 Drive time: 45 min",
        "passions": [
          "hiking",
          "nature"
        ],
        "lodging": "camper"
      },
      {
        "day": 2,
        "name": "Morning Run in Valley of Fire & Drive to Willow Beach (Lake Mead / Hoover Dam)",
        "text": "Begin the day with a run weaving between sandstone outcrops and petroglyphs. After lunch, drive south via Lake Mead and Hoover Dam before reaching Willow Beach Campground by the Colorado River — a quiet spot with dramatic canyon views.\n\n🏃 Suggested run: 8–10 km",
        "drive": "🚐 Drive time: 1.5 hrs",
        "passions": [
          "nature"
        ],
        "lodging": "camper"
      },
      {
        "day": 3,
        "name": "Grand Canyon West & Drive to Sedona",
        "text": "Start early for today’s longer drive. Stop at Grand Canyon West for sweeping rim views and the glass Skywalk platform. Optional short rim jog to stretch the legs. Continue south to Sedona, where the cliffs glow at sunset.\n\n🏃 Optional run: 3–5 km",
        "drive": "🚐 Drive time: 6 hrs",
        "passions": [
          "hiking"
        ],
        "lodging": "camper"
      },
      {
        "day": 4,
        "name": "Sedona Trails Coaching Session",
        "text": "Meet a certified coach at your camper for a private 60-minute trail-running session. Learn efficient uphill pacing, downhill control, and movement over rocky terrain. Afternoon options: relax in a café, browse art galleries, or take a jeep tour.\n\n🏃 Suggested run: 8–12 km",
        "experiences": [
          "trail-running-coaching-sedona-rv-holiday"
        ],
        "passions": [
          "trail-running",
          "hiking"
        ],
        "lodging": "camper"
      },
      {
        "day": 5,
        "name": "Sedona Rest & Exploration",
        "text": "Day off running. Options include hiking Cathedral Rock, exploring Oak Creek Canyon, joining a vortex meditation, or enjoying a spa day. At night, stargazing is excellent thanks to Sedona’s Dark Sky designation.\n\n🏃 Plan: Rest day",
        "passions": [],
        "lodging": "camper"
      },
      {
        "day": 6,
        "name": "Sedona Sunrise Run & Drive to Kingman (Route 66 Stopover)",
        "text": "Optional sunrise run before departure. Drive west to Kingman, Arizona — a classic Route 66 stop with vintage diners, neon signs, and Americana charm.\n\n🏃 Optional run: 5–7 km",
        "drive": "🚐 Drive time: 3 hrs",
        "passions": [],
        "lodging": "camper"
      },
      {
        "day": 7,
        "name": "Drive to Las Vegas & Explore the City",
        "text": "Complete the final leg back to Vegas. Check into a hotel or stay in your RV at Red Rock Campground or an RV park near the Strip. Spend the afternoon exploring the city’s iconic neon, food spots, and shows.",
        "drive": "🚐 Drive time: 1 hr 45 min",
        "passions": [
          "nature"
        ],
        "lodging": "hotel"
      },
      {
        "day": 8,
        "name": "Vegas Day 2 & Departure",
        "text": "Enjoy a relaxed second day in Las Vegas. Options include visiting the Neon Museum, Fremont Street, or a day spa session. Depart later that day or extend your stay for more city time before flying home.",
        "passions": [],
        "lodging": "hotel"
      }
    ]
  },
  {
    "id": "south-africa-horse-riding-holiday-with-motohome-experience",
    "title": "South Africa Horse Riding, Coast & Winelands Roadtrip",
    "passions": [
      "horse-riding",
      "nature",
      "wildlife",
      "adventure",
      "wine"
    ],
    "pick_up_country": "South Africa",
    "pick_up_location": "",
    "route_source": "Shopify export",
    "status": "complete",
    "provenance": "local expert",
    "days_total": 10,
    "distance_km": null,
    "toy": null,
    "days": [
      {
        "day": 1,
        "name": "Pick Up in Port Elizabeth → Addo (Night in Park)",
        "drive": "🚐 ~1 h, 72km",
        "start": "",
        "end": "Pick Up in Port Elizabeth →",
        "text": "Collect your campervan, stock up on supplies, and drive to Addo. Settle into the SANParks campsite before enjoying your first night under the bush sky.",
        "passions": [
          "nature"
        ],
        "lodging": "camper"
      },
      {
        "day": 2,
        "name": "Addo Safari Day (2nd Night in Park)",
        "drive": "",
        "start": "Pick Up in Port Elizabeth →",
        "end": "Addo Safari Day (2nd Night in",
        "text": "Spend the day on self-drive loops through Addo, spotting elephants at waterholes, zebra on the plains, and a wide range of birdlife. Return to camp for a relaxed evening in the park.\n🚐 Self-drive safari, your choice of distance",
        "passions": [
          "nature",
          "wildlife"
        ],
        "lodging": "camper"
      },
      {
        "day": 3,
        "name": "Amakhala Game Reserve Ride → Overnight Nearby",
        "drive": "🚐 ~40 min (+ short return if staying off-reserve)",
        "start": "Addo Safari Day (2nd Night in",
        "end": "Amakhala Game Reserve Ride → Overnight",
        "text": "Drive ~40 minutes east to Amakhala for a full-day guided horseback ride through the bushveld, with wildlife viewing and a picnic stop. Overnight on the reserve if available, or at a campsite near Port Elizabeth.",
        "experiences": [
          "amakhala-horseback-safari"
        ],
        "passions": [
          "horse-riding",
          "nature",
          "wildlife"
        ],
        "lodging": "camper"
      },
      {
        "day": 4,
        "name": "Amakhala → Tsitsikamma (SANParks)",
        "drive": "🚐 ~2 h, 190 km",
        "start": "Amakhala Game Reserve Ride → Overnight",
        "end": "Amakhala → Tsitsikamma (SANParks)",
        "text": "Head west to Tsitsikamma National Park (190 km / ~2 h), a striking part of the Garden Route where dense forest meets rugged coastline. Walk the famous suspension bridge across the Storms River mouth or follow one of the short coastal or forest trails. Campsites sit right above the ocean, making it the perfect place to watch the waves and cook out.",
        "passions": [
          "nature"
        ],
        "lodging": "camper"
      },
      {
        "day": 5,
        "name": "Tsitsikamma → Knysna &amp; Wilderness Stops → Gletana Beach",
        "drive": "🚐 ~2 h 45, 230 km",
        "start": "Amakhala → Tsitsikamma (SANParks)",
        "end": "Tsitsikamma → Knysna & Wilderness Stops",
        "text": "Follow the Garden Route, stopping for lunch at Knysna’s lagoon and a photo stop at Wilderness Beach. Continue to Gletana and enjoy a sundown stroll along the sand.",
        "passions": [],
        "lodging": "camper"
      },
      {
        "day": 6,
        "name": "Gletana Sunrise Beach Ride → Doornkraal Farm (2 Nights)",
        "drive": "🚐 ~1 h 30, 120 km",
        "start": "Tsitsikamma → Knysna & Wilderness Stops",
        "end": "Gletana Sunrise Beach Ride → Doornkraal",
        "text": "Start with a morning ride on Gletana Beach, with the option to walk or canter along the surf. After lunch, cross the Outeniqua Pass to Doornkraal Farm in the Klein Karoo.",
        "experiences": [
          "gletana-beach-ride"
        ],
        "passions": [
          "horse-riding"
        ],
        "lodging": "camper"
      },
      {
        "day": 7,
        "name": "Doornkraal Full-Day Ride (2nd Night on Farm)",
        "drive": "🚐 Drive: minimal",
        "start": "Gletana Sunrise Beach Ride → Doornkraal",
        "end": "Doornkraal Full-Day Ride (2nd Night on",
        "text": "Enjoy a full-day ride from Doornkraal, crossing ridges, plains, and farm tracks with sweeping Karoo views. Evenings are for farm meals, local wine, and stargazing.",
        "experiences": [
          "doornkraal-farm-bush-riding-stay"
        ],
        "passions": [
          "horse-riding",
          "wine"
        ],
        "lodging": "camper"
      },
      {
        "day": 8,
        "name": "Doornkraal → Franschhoek (Cape Winelands)",
        "drive": "",
        "start": "Doornkraal Full-Day Ride (2nd Night on",
        "end": "Doornkraal → Franschhoek (Cape Winelands)",
        "text": "Cross the Karoo to reach Franschhoek (420 km / 5–6 h). Check into a vineyard stay and reward yourself with a special dinner in the valley.\n🚐 5–6 h, 420 km",
        "passions": [
          "nature",
          "wine"
        ],
        "lodging": "camper"
      },
      {
        "day": 9,
        "name": "Winelands Day",
        "drive": "",
        "start": "Doornkraal → Franschhoek (Cape Winelands)",
        "end": "Winelands Day",
        "text": "Spend a relaxed day exploring Franschhoek and Stellenbosch vineyards, enjoying tastings, cellar tours, and a long vineyard lunch.\n🚐 minimal",
        "experiences": [
          "stay-with-your-rv-in-a-winelands-vineyard"
        ],
        "passions": [
          "wine"
        ],
        "lodging": "camper"
      },
      {
        "day": 10,
        "name": "Vineyard Brunch → Cape Town (Start 3 Hotel Nights)",
        "drive": "🚐 ~1 h 15, 80 km",
        "start": "Winelands Day",
        "end": "Vineyard Brunch → Cape Town (Start",
        "text": "Begin with a vineyard brunch, then drive to Cape Town (80 km / ~1 h 15). Drop off the campervan, check into your hotel, and enjoy your first Cape Town sunset.",
        "passions": [
          "wine"
        ],
        "lodging": "hotel"
      },
      {
        "day": 11,
        "name": "13 – Cape Town Highlights",
        "drive": "",
        "start": "Vineyard Brunch → Cape Town (Start",
        "end": "13 – Cape Town Highlights",
        "text": "Explore Cape Town’s icons: Table Mountain, Cape Peninsula, Boulders Beach penguins, and Camps Bay or Clifton for beach time. Take in Robben Island and sample the city’s food and wine scene.\n🚐 minimal",
        "passions": [
          "wildlife",
          "wine"
        ],
        "lodging": "camper"
      }
    ]
  },
  {
    "id": "south-of-france-monaco-a-self-guided-running-adventure",
    "title": "Runner’s Riviera: From Marseille to Monaco with 5 Iconic Coastal Runs",
    "passions": [],
    "pick_up_country": "",
    "pick_up_location": "",
    "route_source": "Shopify export",
    "status": "complete",
    "provenance": "hand curated",
    "days_total": null,
    "distance_km": null,
    "toy": null,
    "days": [
      {
        "day": 1,
        "name": "Pick Up in Marseille",
        "drive": "🚐 Drive time: approx. 45 minutes.",
        "start": "",
        "end": "Pick Up in Marseille",
        "text": "Collect your campervan, grab supplies at the market, and head to Cassis near the Calanques. Camp near the sea and enjoy a gentle shakeout walk.\nDrive time: approx. 45 minutes.",
        "passions": [],
        "lodging": "camper"
      },
      {
        "day": 2,
        "name": "Calanques Trail Run",
        "drive": "🚐 Drive time: none.",
        "start": "Pick Up in Marseille",
        "end": "Calanques Trail Run",
        "text": "Run from Cassis to Calanque d’En Vau: limestone cliffs, pine forests, and secluded turquoise coves. Cool off with a swim, then enjoy dinner under the stars.\nDrive time: none.",
        "passions": [],
        "lodging": "camper"
      },
      {
        "day": 3,
        "name": "Drive to Verdon Gorge + Easy Jog",
        "drive": "🚐 Drive time: approx. 2.5 hours.",
        "start": "Calanques Trail Run",
        "end": "Verdon Gorge + Easy Jog",
        "text": "Make your way inland to Verdon Gorge, stopping for lunch by the lake. In the evening, jog a scenic trail along the rim or take a sunset walk through lavender fields.\nDrive time: approx. 2.5 hours.",
        "passions": [],
        "lodging": "camper"
      },
      {
        "day": 4,
        "name": "Esterel Red Rock Trail",
        "drive": "🚐 Drive time: approx. 2 hours.",
        "start": "Verdon Gorge + Easy Jog",
        "end": "Esterel Red Rock Trail",
        "text": "Head to the Estérel Massif. Run the Cap du Dramont loop: red rock cliffs, sea breeze, and sweeping views. Sleep in the forest near the coast.\nDrive time: approx. 2 hours.",
        "passions": [],
        "lodging": "camper"
      },
      {
        "day": 5,
        "name": "Morning Run in Nice + Ormonico Park Afternoon",
        "drive": "🚐 Drive time: approx. 1.5 hours.",
        "start": "Esterel Red Rock Trail",
        "end": "Morning Run in Nice + Ormonico",
        "text": "Arrive in Nice and run along the Promenade des Anglais at sunrise. Then head to Ormonico Park, a peaceful garden retreat with sculpture paths, shaded walks, and views across the city.\nDrive time: approx. 1.5 hours.",
        "passions": [],
        "lodging": "camper"
      },
      {
        "day": 6,
        "name": "Monaco GP Circuit Run + Spa Day",
        "drive": "🚐 Drive time: approx. 30–45 minutes.",
        "start": "Morning Run in Nice + Ormonico",
        "end": "Monaco GP Circuit Run + Spa",
        "text": "Wake early and drive into Monaco. Run the full Formula 1 loop before the traffic builds. Then refresh with a day-pass at a local spa — hot showers, recovery zones, and maybe even a steam room. Return to your van for a cool drink and dinner by the coast.\nDrive time: approx. 30–45 minutes.",
        "passions": [],
        "lodging": "camper"
      },
      {
        "day": 7,
        "name": "Rest Day in Eze or Villefranche",
        "drive": "🚐 Drive time: minimal.",
        "start": "Monaco GP Circuit Run + Spa",
        "end": "Rest Day in Eze or Villefranche",
        "text": "After a big week of running, take a true rest day. Visit the hilltop village of Eze or relax on the beach at Villefranche-sur-Mer. Optionally walk a short clifftop trail.\nDrive time: minimal.",
        "passions": [],
        "lodging": "camper"
      },
      {
        "day": 8,
        "name": "Return Camper in Nice",
        "drive": "🚐 Drive time: approx. 30–45 minutes.",
        "start": "Rest Day in Eze or Villefranche",
        "end": "Return Camper in Nice",
        "text": "Final coffee in the old town or by the port, then return your campervan in Nice.\nDrive time: approx. 30–45 minutes.",
        "passions": [],
        "lodging": "camper"
      }
    ]
  },
  {
    "id": "st-andrews-fife-coast-scotland",
    "title": "Links, Lochs & Legends: A Scottish Campervan Golfing Pilgrimage",
    "passions": [
      "golf",
      "history",
      "whiskey",
      "hiking",
      "scenery"
    ],
    "pick_up_country": "",
    "pick_up_location": "Edinburgh",
    "route_source": "Shopify export",
    "status": "complete",
    "provenance": "hand curated",
    "days_total": "5-10",
    "distance_km": null,
    "toy": null,
    "days": [
      {
        "day": 1,
        "name": "Edinburgh to Crail",
        "text": "Pick up your campervan in Edinburgh and begin your journey north. Cross the Forth Bridge into Fife and arrive in Crail, a picturesque fishing village with cobbled streets and a dramatic coastal backdrop. Enjoy a seafood dinner in the harbour and get settled near your first course.",
        "drive": "🚐 Drive time: ~1.5 hrs",
        "passions": [
          "golf",
          "scenery"
        ],
        "lodging": "camper"
      },
      {
        "day": 2,
        "name": "⛳ Crail Balcomie Links & Explore East Neuk",
        "text": "Play 18 holes at Crail’s historic Balcomie Links—one of the world’s oldest clubs, offering fast-running fairways and stunning views over the North Sea. Spend your afternoon exploring the East Neuk’s harbour villages and walking the coast.",
        "drive": "🚐 Drive time: minimal",
        "passions": [
          "golf",
          "history",
          "hiking",
          "scenery"
        ],
        "lodging": "camper"
      },
      {
        "day": 3,
        "name": "⛳ St Andrews Old Course / Jubilee / New Course",
        "text": "Head to St Andrews, the spiritual home of golf. If you've secured a ballot spot, tee off on the legendary Old Course. Otherwise, the Jubilee and New Courses provide top-tier links play. Visit the British Golf Museum, stroll the ancient town, and enjoy the vibrant local pubs and restaurants.",
        "drive": "🚐 Drive time: ~30 mins",
        "passions": [
          "golf",
          "history"
        ],
        "lodging": "camper"
      },
      {
        "day": 4,
        "name": "Edradour or Blair Atholl",
        "text": "Distillery TourDrive inland toward Pitlochry, a gateway to the Highlands. Visit the charming Edradour Distillery—Scotland’s smallest traditional distillery set in beautiful whitewashed buildings surrounded by woods and streams. Tour the stillhouse, learn about their unique single malts, and enjoy a scenic tasting session. Camp nearby in the hills.",
        "drive": "🚐 Drive time: ~2 hrs",
        "passions": [
          "scenery"
        ],
        "lodging": "camper"
      },
      {
        "day": 5,
        "name": "Highlands & Lochs",
        "text": "Spend the day exploring Highland landscapes. Hike Glen Nevis or the Lost Valley in Glencoe, drive scenic passes through the Cairngorms, or relax by a loch with a picnic. Camp lakeside for a starlit Highland night.",
        "drive": "🚐 Drive time: flexible depending on routes",
        "passions": [
          "hiking",
          "scenery"
        ],
        "lodging": "camper"
      },
      {
        "day": 6,
        "name": "Highlands to Machrihanish",
        "text": "Continue west through sweeping Highland roads and shimmering lochs to reach the Kintyre Peninsula. Arrive at Machrihanish Golf Club, where you can park your campervan right on-site & stay overnight. Stroll the wild Atlantic beach and enjoy a sunset pint.",
        "drive": "🚐 Drive time: ~4 hrs",
        "passions": [
          "golf",
          "scenery"
        ],
        "lodging": "camper"
      },
      {
        "day": 7,
        "name": "⛳ Machrihanish Golf Club & West Coast Views",
        "text": "Play Machrihanish, famous for its thrilling opening tee shot across the beach and natural links character. This rugged course rewards adventurous golfers with its scenery and solitude. Explore Campbeltown or relax at your coastal campsite.",
        "drive": "🚐 Drive time: minimal",
        "passions": [
          "golf"
        ],
        "lodging": "camper"
      },
      {
        "day": 8,
        "name": "Loch Lomond & the Trossachs",
        "text": "Begin your return with a drive back east through Scotland’s first national park. Stop at Loch Lomond for a boat trip, hike to a lochside viewpoint, or enjoy a waterside lunch. Camp near Balmaha or Aberfoyle for your final night in nature.",
        "drive": "🚐 Drive time: ~3 hrs",
        "passions": [
          "hiking"
        ],
        "lodging": "camper"
      },
      {
        "day": 9,
        "name": "⛳ Gleneagles King’s Course & Explore Perthshire",
        "text": "Tee off at the King’s Course at Gleneagles, a beautiful inland championship course famed for its lush fairways and heritage. After golf, stroll the grounds, visit the spa, or toast your trip at the Dormy Clubhouse.",
        "drive": "🚐 Drive time: ~1.5 hrs",
        "passions": [
          "golf",
          "history"
        ],
        "lodging": "camper"
      },
      {
        "day": 10,
        "name": "Falkirk & Return to the LowlandsDrive to Falkirk to see the engineering wonder of the Falkirk Wheel or the iconic Kelpies sculptures. Spend your final evening near the River Forth or in a peaceful rural site near Linlithgow.🚐 Drive time: ~1 hr",
        "text": "",
        "passions": [],
        "lodging": "camper"
      },
      {
        "day": 11,
        "name": "Return to Edinburgh & Drop-Off",
        "text": "Complete your journey with a short drive back to Edinburgh. Drop off your campervan and enjoy a final breakfast in Dean Village or Leith before heading home.\n\n✨ Optional ExtensionFor the adventurous traveller, extend your trip north to:\n\n- Royal Dornoch – Top-ranked Highlands links course with golden dunes and rich history\n\n- Durness Golf Club – Wild 9-hole gem at the edge of Scotland, along the famed North Coast 500\n\n- Royal Troon – Prestigious Open venue in Ayrshire for a west coast finale\n\nThis extended route adds the dramatic Highland scenery & remote beaches of the stunning 'North Coast 500', and even more world-class golf to your journey.",
        "drive": "🚐 Drive time: ~30 mins",
        "passions": [
          "golf",
          "history",
          "scenery"
        ],
        "lodging": "camper"
      }
    ]
  },
  {
    "id": "st-andrews-heritage-links-fife-coast-golf-scotland-with-a-camper-copy",
    "title": "Italian Lakes & Fairways: Northern Italy Campervan Golf Journey",
    "passions": [],
    "pick_up_country": "",
    "pick_up_location": "",
    "route_source": "Shopify export",
    "status": "complete",
    "provenance": "hand curated",
    "days_total": null,
    "distance_km": null,
    "toy": null,
    "days": [
      {
        "day": 1,
        "name": "Arrival & Drive to Bergamo",
        "drive": "🚐 Drive time: ~1 hr",
        "start": "",
        "end": "Arrival & Drive to Bergamo",
        "text": "Pick up your campervan in Milan and drive through Lombardy’s gentle hills lined with vineyards and cypress trees. Arrive in Bergamo in time to walk the ancient Venetian walls, climb the Torre Civica for sweeping views, and enjoy dinner in a candlelit trattoria tucked inside the medieval Città Alta.",
        "passions": [],
        "lodging": "camper"
      },
      {
        "day": 2,
        "name": "⛳ Golf Club L’Albenza",
        "drive": "🚐 Drive time: minimal",
        "start": "Arrival & Drive to Bergamo",
        "end": "⛳ Golf Club L’Albenza",
        "text": "Tee off on this 27-hole championship course with tree-lined fairways and undulating greens, famous as a past Italian Open venue. After your round, visit the Accademia Carrara’s collection of Renaissance art or relax over an aperitivo in Piazza Vecchia. You can sleep overnight in your campervan on the club grounds by prior arrangement.",
        "passions": [],
        "lodging": "camper"
      },
      {
        "day": 3,
        "name": "Lake Como & ⛳ Villa d’Este Golf",
        "drive": "🚐 Drive time: ~1 hr",
        "start": "⛳ Golf Club L’Albenza",
        "end": "Lake Como & ⛳ Villa d’Este",
        "text": "Play 18 holes at Villa d’Este, Italy’s most prestigious club, known for its immaculate fairways set among chestnut and birch trees. Later, sip espresso in Bellagio’s piazza, browse artisan boutiques, or sail across Lake Como as the sun sets over the mountains.",
        "passions": [],
        "lodging": "camper"
      },
      {
        "day": 4,
        "name": "Lake Como & Mountain Escape",
        "drive": "🚐 Drive time: ~2 hrs",
        "start": "Lake Como & ⛳ Villa d’Este",
        "end": "Lake Como & Mountain Escape",
        "text": "Start with a lakeside breakfast, then drive into the Alps to Camping Cevedale. Settle into this peaceful mountain retreat surrounded by forests, waterfalls, and panoramic peaks.",
        "passions": [],
        "lodging": "camper"
      },
      {
        "day": 5,
        "name": "Dolomites & ⛳ Dolomiti Golf Club",
        "drive": "🚐 Drive time: ~1 hr",
        "start": "Lake Como & Mountain Escape",
        "end": "Dolomites & ⛳ Dolomiti Golf Club",
        "text": "Continue into the heart of the Dolomites to play 18 holes framed by dramatic limestone cliffs and alpine meadows. This high-altitude course is renowned for fresh mountain air and unforgettable scenery. Stay overnight at the course in your campervan.",
        "passions": [],
        "lodging": "camper"
      },
      {
        "day": 6,
        "name": "Dolomites Exploration",
        "drive": "🚐 Drive time: minimal",
        "start": "Dolomites & ⛳ Dolomiti Golf Club",
        "end": "Dolomites Exploration",
        "text": "Spend the day hiking panoramic trails with views of the Pale di San Martino, exploring traditional mountain villages, or tasting local Tyrolean cuisine.",
        "passions": [],
        "lodging": "camper"
      },
      {
        "day": 7,
        "name": "Lake Garda & ⛳ Garda Golf Country Club",
        "drive": "🚐 Drive time: ~2.5 hrs",
        "start": "Dolomites Exploration",
        "end": "Lake Garda & ⛳ Garda Golf",
        "text": "Drive south to Lake Garda to play 27 holes among olive groves and cypress trees. After golf, explore Sirmione’s castle, stroll lakeside promenades, and relax in thermal springs.",
        "passions": [],
        "lodging": "camper"
      },
      {
        "day": 8,
        "name": "Verona & Opera Night",
        "drive": "🚐 Drive time: ~1 hr",
        "start": "Lake Garda & ⛳ Garda Golf",
        "end": "Verona & Opera Night",
        "text": "Wander Verona’s romantic cobblestone streets, admire Juliet’s Balcony, and savour gelato in Piazza delle Erbe. In the evening, experience an unforgettable opera performance in the Roman Arena.",
        "passions": [],
        "lodging": "camper"
      },
      {
        "day": 9,
        "name": "Return to Milan & Camper Drop-Off",
        "drive": "🚐 Drive time: ~2 hrs",
        "start": "Verona & Opera Night",
        "end": "Milan & Camper Drop-Off",
        "text": "Drive back to Milan, return your campervan, and check into a central hotel. Spend your last evening shopping in the fashion district or toasting your trip in the vibrant Navigli area.",
        "passions": [],
        "lodging": "hotel"
      },
      {
        "day": 10,
        "name": "Milan Culture & Departure",
        "drive": "🚐 Drive time: minimal",
        "start": "Milan & Camper Drop-Off",
        "end": "Milan Culture & Departure",
        "text": "Visit the Duomo’s rooftop terraces, see Da Vinci’s Last Supper, and enjoy a farewell breakfast before heading home.\n\nOptional Venice Extension: If you’d like to continue your adventure towards Venice, consider adding extra days for ⛳ Castello di Spessa Golf Club, where you can also park your campervan on site. This makes a perfect base for exploring Venice’s canals and the Friuli wine region.",
        "passions": [],
        "lodging": "camper"
      }
    ]
  },
  {
    "id": "warm-up-for-your-marathon-training-camp-road-trip-greek-edition",
    "title": "COMING SOON: Warm-up for your marathon: Training camp & road trip — Greek Edition",
    "passions": [
      "beach",
      "mountains",
      "history",
      "trail-running",
      "old-towns"
    ],
    "pick_up_country": "Greece",
    "pick_up_location": "Athens",
    "route_source": "Shopify export",
    "status": "complete",
    "provenance": "hand curated",
    "days_total": 10,
    "distance_km": 1290,
    "toy": null,
    "days": [
      {
        "day": 1,
        "name": "Arrive in Athens & Drive to Meteora + Welcome Dinner",
        "drive": "🚐 Drive time: ~3.5–4 hours",
        "start": "",
        "end": "Athens & Drive to Meteora +",
        "text": "Arrive in Athens and drive north to Meteora. Settle in and meet the group for a relaxed welcome dinner with the coach.\n\n🗓️",
        "passions": [],
        "lodging": "camper"
      },
      {
        "day": 2,
        "name": "Meteora Trail Circuit (Warm-up & Technique)",
        "drive": "",
        "start": "Athens & Drive to Meteora +",
        "end": "Meteora Trail Circuit (Warm-up & Technique)",
        "text": "Early morning run along the Meteora trails. This area is a UNESCO site where giant rock towers rise from the plain, creating an unforgettable backdrop for your run. Short video checks and clear tips to try straight away.\n🏃‍♂️ Suggested run: 10.02km, 428m elevation\n\n🗓️",
        "passions": [
          "trail-running"
        ],
        "lodging": "camper"
      },
      {
        "day": 3,
        "name": "Meteora Long Run & Evening Social",
        "drive": "",
        "start": "Meteora Trail Circuit (Warm-up & Technique)",
        "end": "Meteora Long Run & Evening Social",
        "text": "Steady long run through the monasteries with straightforward pointers as you go (8 km loop and choose 1–3 laps). Evening drinks together.\n🏃‍♂️ Suggested run: 8–24km (8km loop × 1–3)\n\n🗓️",
        "passions": [],
        "lodging": "camper"
      },
      {
        "day": 4,
        "name": "Drive to Zagori & Vikos Gorge",
        "drive": "🚐 Drive time: ~2.5–3 hours",
        "start": "Meteora Long Run & Evening Social",
        "end": "Zagori & Vikos Gorge",
        "text": "Drive to the Zagori region, stopping to see the remarkable Stone Forest rock formations, beautiful Vikos Gorge viewpoints, and centuries-old monasteries. Vikos Gorge is listed by Guinness World Records as the deepest gorge in the world relative to its width, with cliffs over 1,000 meters high plunging into a narrow canyon floor.\n\n🗓️",
        "passions": [],
        "lodging": "camper"
      },
      {
        "day": 5,
        "name": "Zagori Run & Drive to Corfu + Corfu Old Town",
        "drive": "🚐 Drive time: ~2 hours + ferry",
        "start": "Zagori & Vikos Gorge",
        "end": "Zagori Run & Drive to Corfu",
        "text": "Begin the day with a trail run through Zagori’s stone bridge network—arching footbridges from the 18th century that connect tiny mountain villages. The route winds through oak forest and over quiet rivers. Afterward, drive to Igoumenitsa. Take the ferry across to Corfu and settle in, then in the evening, explore Corfu Old Town’s cobblestone lanes, Venetian architecture, and lively tavernas.\n🏃‍♂️ Suggested run: 9.62km, 505m elevation\n\n🗓️",
        "passions": [
          "trail-running"
        ],
        "lodging": "camper"
      },
      {
        "day": 6,
        "name": "Cliff-top Trail & Corfu Beach",
        "drive": "🚐 Drive time: ~1–2 hours depending on choice of activities on Corfu",
        "start": "Zagori Run & Drive to Corfu",
        "end": "Cliff-top Trail & Corfu Beach",
        "text": "Begin the day with a cliff-top morning trail run, where narrow paths lead to stunning cliff viewpoints and turquoise coves. This is one of Corfu’s most photographed spots, and the run here is both scenic and peaceful. Afternoon beach time.\n🏃‍♂️ Suggested run: 8.85km, 140m elevation\n\n🗓️",
        "passions": [
          "beach",
          "trail-running"
        ],
        "lodging": "camper"
      },
      {
        "day": 7,
        "name": "Corfu Relax / Easy Day",
        "drive": "",
        "start": "Cliff-top Trail & Corfu Beach",
        "end": "Corfu Relax / Easy Day",
        "text": "Given the beauty of Corfu, the excellent campsite, and the many great things to do on the island, you may wish to stay longer before continuing. Optional easy coastal shake-out.\n\n🗓️",
        "passions": [
          "beach"
        ],
        "lodging": "camper"
      },
      {
        "day": 8,
        "name": "Return to Mainland & Drive to Delphi (PM visit)",
        "drive": "🚐 Drive time: ~5–6 hours including ferry",
        "start": "Corfu Relax / Easy Day",
        "end": "Mainland & Drive to Delphi (PM",
        "text": "Take the early morning ferry back to the mainland. Drive south to Delphi and settle in for the night. Spend the afternoon exploring Delphi’s Sacred Way and the Sanctuary of Apollo. At the top of the site, you’ll find the ancient stadium, once used for athletic competitions as part of the Pythian Games—its stone seating and starting lines still visible.\n\n🗓️",
        "passions": [
          "beach",
          "history"
        ],
        "lodging": "camper"
      },
      {
        "day": 9,
        "name": "Drive to Athens (Return Van) & Hotel Night",
        "drive": "🚐 Drive time: ~2.5 hours",
        "start": "Mainland & Drive to Delphi (PM",
        "end": "Athens (Return Van) & Hotel Night",
        "text": "Drive to Athens, return your campervan, and check in to your hotel. In the evening, enjoy a cocktail from one of Athens’ fantastic rooftop bars with views over the illuminated Acropolis.\n\n🗓️",
        "passions": [],
        "lodging": "hotel"
      },
      {
        "day": 10,
        "name": "Athens Olympic Stadium Run & Departure",
        "drive": "",
        "start": "Athens (Return Van) & Hotel Night",
        "end": "Athens Olympic Stadium Run & Departure",
        "text": "Start your morning with a final run around the Panathenaic Stadium—built entirely of marble and the site of the first modern Olympic Games in 1896. The stadium is open to the public for jogging sessions, so you can experience running on this historic track. Finish your trip by exploring Athens highlights such as the Acropolis before taking your evening flight home, or extend your journey to experience more of Greece’s wonders.\n🏃‍♂️ Suggested run: 1500m, 0m elevation",
        "passions": [
          "history"
        ],
        "lodging": "camper"
      }
    ]
  },
  {
    "id": "western-cape-running-tour",
    "title": "The Western Cape Mountains Loop: Hiking, Biking, Trail-Running & Wine",
    "passions": [
      "running",
      "trail-running",
      "mountains",
      "nature",
      "wine",
      "stargazing"
    ],
    "pick_up_country": "",
    "pick_up_location": "",
    "route_source": "Shopify export",
    "status": "complete",
    "provenance": "local expert",
    "days_total": "8-12",
    "distance_km": 575,
    "toy": null,
    "days": [
      {
        "day": 1,
        "name": "— 22 Waterfalls",
        "drive": "🚐 Drive time: approx 1.5 hours",
        "start": "",
        "end": "— 22 Waterfalls",
        "text": "Your journey begins at the dramatic 22 Waterfalls trail, a steep and adventurous hike that climbs beside a chain of waterfalls. The path rises sharply up the mountain face, crossing cool pools and rocky steps as the views open wider with every section. From the top, you look back across the whole valley while the sound of water echoes below.\n🥾 Run/Hike: steep waterfall trail (non-running day)",
        "passions": [
          "running",
          "trail-running",
          "nature"
        ],
        "lodging": "camper"
      },
      {
        "day": 2,
        "name": "— Into the Cederberg & Sanddrif",
        "drive": "🚐 Drive time: approx 2 hours",
        "start": "— 22 Waterfalls",
        "end": "— Into the Cederberg & Sanddrif",
        "text": "Travel into the rugged Cederberg, entering red-rock valleys and sandstone towers. At Sanddrif’s beautifully maintained, small-scale campsite, take a short walk down to the river to swim in clear mountain pools fed by small waterfalls. In the late afternoon stroll to Cederberg Private Cellar for relaxed tastings of award-winning high-altitude wines. As darkness arrives, enjoy a braai under huge cliffs with excellent stargazing.\n🥾 Short hike + swimming rock pools (non-running day)",
        "passions": [
          "running",
          "nature",
          "wine"
        ],
        "lodging": "camper",
        "experiences": [
          "sanddrif-stay-wine-tasting-cederberg"
        ]
      },
      {
        "day": 3,
        "name": "— Wolfberg Cracks & The Arch",
        "drive": "",
        "start": "— Into the Cederberg & Sanddrif",
        "end": "— Wolfberg Cracks & The Arch",
        "text": "A spectacular run–hike takes you up into the Wolfberg Cracks, where deep sandstone corridors and narrow fissures open onto the high plateau. Continue to the Arch, a natural sandstone bridge with sweeping views across the Cederberg. Return to camp for a refreshing swim in the river. If it’s a Saturday, join the Cederberg Observatory for a guided stargazing evening.\n🥾/🏃‍♂️ Run–hike: 6–12 km depending on chosen loop",
        "passions": [
          "running",
          "nature"
        ],
        "lodging": "camper"
      },
      {
        "day": 4,
        "name": "— Cederberg Trails & Into the Karoo",
        "drive": "",
        "start": "— Wolfberg Cracks & The Arch",
        "end": "— Cederberg Trails & Into the",
        "text": "Start the morning with a 5–20 km trail loop around Sanddrif, with options through valleys or up to viewpoints. Later drive deeper into the mountains and wind along gravel roads into the edge of the Karoo, where the landscape opens to quiet plateaus and wide silence. Spend the night at another remarkable campsite far from civilisation, under an immense canopy of stars.\n🏃‍♂️ Run: 5–20 km (your choice)\n🚐 Drive: Cederberg gravel roads into Karoo",
        "passions": [
          "running",
          "trail-running",
          "nature"
        ],
        "lodging": "camper"
      },
      {
        "day": 5,
        "name": "— Karoo Morning & Mount Ceder",
        "drive": "",
        "start": "— Cederberg Trails & Into the",
        "end": "— Karoo Morning & Mount Ceder",
        "text": "Wake to a calm desert atmosphere before driving back toward the eastern Cederberg valleys. Arrive at Mount Ceder for private, peaceful campsites surrounded by sandstone cliffs. Enjoy river swims, easy trail options, mountain-bike-friendly gravel tracks and the chance to kayak on the private estate lake. End the day dining at the restaurant or braaiing under a warm night sky.\n🏃 Easy optional run: 5–10 km\n🚐 Drive: approx 1.5 hours",
        "passions": [
          "running",
          "trail-running",
          "nature",
          "wine"
        ],
        "lodging": "camper",
        "experiences": [
          "mount-ceder-private-campsite-mtb-kayak"
        ]
      },
      {
        "day": 6,
        "name": "— Arrival in Franschhoek",
        "drive": "",
        "start": "— Karoo Morning & Mount Ceder",
        "end": "— Arrival in Franschhoek",
        "text": "Head south toward Franschhoek, arriving in the afternoon in time to explore the town’s galleries, cafés and small boutiques. The valley scenery shifts from rugged mountains to vineyards and manicured gardens. In the evening enjoy high-quality dining, with tasting menus and wine pairings among South Africa’s best.\n🚐 Drive: approx 2 hours",
        "passions": [
          "nature",
          "wine"
        ],
        "lodging": "camper",
        "experiences": [
          "chefs-warehouse-vineyard-tapas-franschhoek"
        ]
      },
      {
        "day": 7,
        "name": "— Vineyard Run & Wine Tram or Motor Museum",
        "drive": "",
        "start": "— Arrival in Franschhoek",
        "end": "— Vineyard Run & Wine Tram",
        "text": "Start the morning with a scenic vineyard run from Mont Rochelle, weaving through farm roads and gentle slopes. Afterwards choose between the Franschhoek Wine Tram or the classic Motor Museum for a relaxed afternoon. Evenings here blend fine dining, cosy wine bars and the serene atmosphere of the valley.\n🏃 Morning run: 5–10 km",
        "passions": [
          "running",
          "nature",
          "wine"
        ],
        "lodging": "camper",
        "experiences": [
          "franschhoek-wine-tram-top-estates"
        ]
      },
      {
        "day": 8,
        "name": "— Jonkershoek, Nectar Gardens & Stellenbosch/Vergelegen",
        "drive": "",
        "start": "— Vineyard Run & Wine Tram",
        "end": "— Jonkershoek, Nectar Gardens & Stellenbosch/Vergelegen",
        "text": "Drive to Jonkershoek for a beautiful 7 km run-hike through its amphitheatre-like valley, surrounded by waterfalls and steep peaks. Afterwards visit the Old Nectar gardens for a tranquil wander through shaded paths and sculpted landscapes. Close the day with either lunch and wine tasting in Stellenbosch or at Vergelegen.\n🏃 Run-hike: 7 km\n🚐 Drive: short transfers",
        "passions": [
          "running",
          "nature",
          "wine"
        ],
        "lodging": "camper"
      },
      {
        "day": 9,
        "name": "11 — Cape Town",
        "drive": "",
        "start": "— Jonkershoek, Nectar Gardens & Stellenbosch/Vergelegen",
        "end": "11 — Cape Town",
        "text": "Spend your final days in Cape Town with time to explore the city’s oceanfront, cafés, markets and viewpoints. Choose between iconic running routes on the Twelve Apostles, Lion’s Head or parts of Table Mountain, each offering a different perspective on the city. Outside of running, enjoy beaches, the V&A Waterfront, museums, the cable car and the city’s vibrant food scene.\n🏃 Optional runs: 5–12 km (various routes)",
        "passions": [
          "running",
          "nature"
        ],
        "lodging": "camper",
        "experiences": [
          "cape-town-kelp-forest-snorkelling"
        ]
      },
      {
        "day": 12,
        "name": "— Departure or Extensions",
        "drive": "",
        "start": "11 — Cape Town",
        "end": "— Departure or Extensions",
        "text": "Enjoy a relaxed final morning before departing. Alternatively extend your adventure with onward options such as the Garden Route, Kruger National Park, a Western Cape game reserve, or a beach week in Mauritius.",
        "passions": [
          "nature"
        ],
        "lodging": "camper"
      }
    ]
  },
  {
    "id": "wild-atlantic-way-family-coastal-campervan",
    "title": "Ireland’s Wild Atlantic Way – Family Coastal Explorer",
    "passions": [
      "surfing",
      "scenery",
      "hiking",
      "beaches",
      "whiskey",
      "history"
    ],
    "pick_up_country": "",
    "pick_up_location": "",
    "route_source": "Shopify export",
    "status": "complete",
    "provenance": "hand curated",
    "days_total": 10,
    "distance_km": 1260,
    "toy": null,
    "days": [
      {
        "day": 1,
        "name": "Cork to Kenmare (~2 hrs)",
        "drive": "",
        "start": "",
        "end": "Cork to Kenmare (~2 hrs)",
        "text": "Pick up your van and head into the hills.",
        "passions": [],
        "lodging": "camper"
      },
      {
        "day": 2,
        "name": "Beara Peninsula",
        "drive": "",
        "start": "Cork to Kenmare (~2 hrs)",
        "end": "Beara Peninsula",
        "text": "Tiny roads, sea views, and Dursey cable car.",
        "passions": [
          "scenery"
        ],
        "lodging": "camper"
      },
      {
        "day": 3,
        "name": "Dingle Peninsula (~2 hrs)",
        "drive": "",
        "start": "Beara Peninsula",
        "end": "Dingle Peninsula (~2 hrs)",
        "text": "Drive via Inch Beach, stay near Dingle Harbour.",
        "passions": [],
        "lodging": "camper"
      },
      {
        "day": 4,
        "name": "Cliffs of Moher (~3 hrs)",
        "drive": "",
        "start": "Dingle Peninsula (~2 hrs)",
        "end": "Cliffs of Moher (~3 hrs)",
        "text": "Lunch stop at Lahinch, cliff views, and camper pitch nearby.",
        "passions": [
          "scenery"
        ],
        "lodging": "camper"
      },
      {
        "day": 5,
        "name": "The Burren & Galway Bay",
        "drive": "",
        "start": "Cliffs of Moher (~3 hrs)",
        "end": "The Burren & Galway Bay",
        "text": "Explore the otherworldly Burren landscape.",
        "passions": [],
        "lodging": "camper"
      },
      {
        "day": 6,
        "name": "Connemara Loop (~2 hrs)",
        "drive": "",
        "start": "The Burren & Galway Bay",
        "end": "Connemara Loop (~2 hrs)",
        "text": "Sheep, ponies, stone walls and wildflowers.",
        "passions": [],
        "lodging": "camper"
      },
      {
        "day": 7,
        "name": "Clifden & Sky Road",
        "drive": "",
        "start": "Connemara Loop (~2 hrs)",
        "end": "Clifden & Sky Road",
        "text": "Visit the Atlantic coast’s quiet side.",
        "passions": [],
        "lodging": "camper"
      },
      {
        "day": 8,
        "name": "Westport & Clew Bay",
        "drive": "",
        "start": "Clifden & Sky Road",
        "end": "Westport & Clew Bay",
        "text": "Culture, music, and Mayo’s friendly vibe.",
        "passions": [],
        "lodging": "camper"
      },
      {
        "day": 9,
        "name": "Wild Beach Stop",
        "drive": "",
        "start": "Westport & Clew Bay",
        "end": "Wild Beach Stop",
        "text": "Let kids roam a quiet sandy cove or inlet.",
        "passions": [],
        "lodging": "camper"
      },
      {
        "day": 10,
        "name": "Return to Cork (~4.5 hrs)",
        "drive": "",
        "start": "Wild Beach Stop",
        "end": "Cork (~4",
        "text": "Take a scenic or direct route back down the country.",
        "passions": [
          "scenery"
        ],
        "lodging": "camper"
      }
    ]
  },
  {
    "id": "wildest-golf-courses-kruger-south-africa",
    "title": "Play the \"Wildest Golf Courses in the World\" - Kruger National Park",
    "passions": [
      "scenery",
      "hiking",
      "nature"
    ],
    "pick_up_country": "South Africa",
    "pick_up_location": "Johannesburg",
    "route_source": "Shopify export",
    "status": "complete",
    "provenance": "local expert",
    "days_total": "8-12",
    "distance_km": 1375,
    "toy": null,
    "days": [
      {
        "day": 1,
        "name": "Collect Camper & Overnight near Leopard Creek",
        "drive": "🚐 Drive time: ~4.5 hours from Johannesburg",
        "start": "",
        "end": "Collect Camper & Overnight near Leopard",
        "text": "Pick up your safari-equipped campervan in Johannesburg and drive to Malelane. Stay just outside Kruger, perfectly positioned for a morning tee time at Leopard Creek.",
        "passions": [],
        "lodging": "camper"
      },
      {
        "day": 2,
        "name": "Leopard Creek Golf & Lower Sabie Rest Camp",
        "drive": "🚐 Drive time: ~2 hours inside the park",
        "start": "Collect Camper & Overnight near Leopard",
        "end": "Leopard Creek Golf & Lower Sabie",
        "text": "Enjoy an early morning round at Leopard Creek Country Club, a world-famous Gary Player design combining immaculate conditioning, elevated tees, and challenging holes hugging the Crocodile River—where you may see hippos or elephants while you play. After golf, enter Kruger via Malelane Gate and drive through mixed woodland and riverine forests. Lookout points like Matjulu and Renosterkoppies provide perfect stops to spot rhino and giraffes. Continue toward Lower Sabie, watching for elephants crossing the road and herds of buffalo grazing along the river.",
        "passions": [
          "nature"
        ],
        "lodging": "camper"
      },
      {
        "day": 3,
        "name": "Skukuza & Optional Golf",
        "drive": "🚐 Drive time: ~45 minutes",
        "start": "Leopard Creek Golf & Lower Sabie",
        "end": "Skukuza & Optional Golf",
        "text": "Morning game drive as you head along the Sabie River, renowned for its concentrations of wildlife, including leopards resting in trees, elephants in the shallows, and hippos basking on sandbanks. Arrive at Skukuza for check-in and an optional round on the bushveld 9-hole Skukuza Golf Course, a gently undulating course lined with indigenous trees and small, challenging greens. The experience of playing here is special because of the chance encounters with impala and warthog wandering across your fairway, and the atmosphere of golfing in the wild.",
        "passions": [
          "nature"
        ],
        "lodging": "camper"
      },
      {
        "day": 4,
        "name": "Morning Golf & Lion Sands River Lodge",
        "drive": "🚐 Drive time: ~2 hours",
        "start": "Skukuza & Optional Golf",
        "end": "Morning Golf & Lion Sands River",
        "text": "Early morning golf at Skukuza before driving through savanna landscapes rich with giraffe, kudu, and zebra. Pause at Nkuhlu Picnic Site to take in views of the Sabie River and possibly spot crocodiles and hippos. Continue to Lion Sands River Lodge to enjoy a luxury stay and sunset guided drives in Big Five country. Option for a sunset guided game drive or to simply relax in the tranquility of this magnificent lodge.",
        "passions": [
          "scenery",
          "nature"
        ],
        "lodging": "camper"
      },
      {
        "day": 5,
        "name": "Lion Sands",
        "drive": "🚐 Drive time: none",
        "start": "Morning Golf & Lion Sands River",
        "end": "Lion Sands",
        "text": "Dawn game drive in an open jeep hosted by your safari guide, taking you close to the Big Five and offering exceptional photographic opportunities. Spend the afternoon relaxing by the pool or enjoying fine dining overlooking the river. You may also choose additional activities such as guided bush walks, birdwatching, or a sunset drive to see nocturnal predators becoming active.",
        "passions": [
          "scenery",
          "hiking",
          "nature"
        ],
        "lodging": "camper"
      },
      {
        "day": 6,
        "name": "Olifants Rest Camp",
        "drive": "🚐 Drive time: ~4 hours",
        "start": "Lion Sands",
        "end": "Olifants Rest Camp",
        "text": "Depart Lion Sands and re-enter Kruger through Orpen Gate, heading north through open savanna and mopane woodland. This part of Kruger is known for large elephant bulls and expansive views across the Olifants River valley. Arrive at Olifants Rest Camp, perched high above the river where you can watch herds gathering below.",
        "passions": [
          "scenery",
          "nature"
        ],
        "lodging": "camper"
      },
      {
        "day": 7,
        "name": "Drive to Hans Merensky / Ba-Phalaborwa Golf",
        "drive": "🚐 Drive time: ~1 hour",
        "start": "Olifants Rest Camp",
        "end": "Hans Merensky / Ba-Phalaborwa Golf",
        "text": "Enjoy your last wildlife sightings as you exit Kruger and travel to Ba-Phalaborwa Golf Course. This course is renowned for broad kikuyu fairways, raised greens framed by bushveld trees, and water hazards that hippos and crocodiles often share. Every hole offers a blend of golfing challenge and safari atmosphere.",
        "passions": [],
        "lodging": "camper"
      },
      {
        "day": 8,
        "name": "Morning Golf & Drive to Panorama Route",
        "drive": "🚐 Drive time: ~2.5 hours",
        "start": "Hans Merensky / Ba-Phalaborwa Golf",
        "end": "Morning Golf & Drive to Panorama",
        "text": "Play a morning round at Ba-Phalaborwa Golf Course before setting out on the Panorama Route. Along this route, expect breathtaking vistas of rugged cliffs, cascading waterfalls, and forested ravines. Highlights include God’s Window, where you can gaze across an endless sweep of green Lowveld plains.",
        "passions": [
          "scenery",
          "nature"
        ],
        "lodging": "camper"
      },
      {
        "day": 9,
        "name": "Panorama Route & Return to Johannesburg",
        "drive": "🚐 Drive time: ~5 hours",
        "start": "Morning Golf & Drive to Panorama",
        "end": "Panorama Route & Return to Johannesburg",
        "text": "Begin your day with sunrise views over Blyde River Canyon, one of Africa’s most impressive landscapes, before driving back to Johannesburg to return your campervan.",
        "passions": [
          "scenery",
          "nature"
        ],
        "lodging": "camper"
      }
    ]
  },
  {
    "id": "iceland-rocks-geology-explorer-by-campervan",
    "title": "Iceland Rocks – Fire, Ice & Earth by 4x4 campervan",
    "passions": ["adventure", "nature", "scenery"],
    "pick_up_country": "Iceland",
    "pick_up_location": "Reykjavik",
    "route_source": "Shopify export",
    "status": "complete",
    "provenance": "hand curated",
    "days_total": 8,
    "distance_km": null,
    "toy": null,
    "days": [
      {
        "day": 1,
        "name": "Lava Centre & Þingvellir",
        "drive": "🚐 Drive time: ~1.5 hours",
        "start": "",
        "end": "Lava Centre & Þingvellir",
        "text": "Pick up your 4x4 campervan in Keflavík and visit the award-winning Lava Centre in Hvolsvöllur. This interactive museum explains Iceland's volcanic systems using real-time earthquake data, multimedia exhibits, and geological models. Continue to Þingvellir National Park, a UNESCO World Heritage Site where you can walk between the North American and Eurasian tectonic plates and explore Iceland's first parliament site.",
        "passions": ["nature", "scenery"],
        "lodging": "camper"
      },
      {
        "day": 2,
        "name": "Geysir, Gullfoss & Hekla Region",
        "drive": "🚐 Drive time: ~3-4 hours",
        "start": "",
        "end": "Geysir, Gullfoss & Hekla Region",
        "text": "See the explosive Strokkur geyser and powerful Gullfoss waterfall before turning onto the F225 mountain track toward the Hekla region. Enjoy scenic river crossings and lava fields shaped by one of Iceland's most active volcanoes. Camp near the edge of Landmannalaugar.",
        "passions": ["nature", "scenery"],
        "lodging": "camper"
      },
      {
        "day": 3,
        "name": "Landmannalaugar Rhyolite Mountains",
        "drive": "🚐 Drive time: ~1-2 hours",
        "start": "",
        "end": "Landmannalaugar Rhyolite Mountains",
        "text": "Drive deeper on F208 to Landmannalaugar, known for steaming geothermal rivers and multi-coloured rhyolite hills. Hike the famous Brennisteinsalda trail, wander through the lava fields of Laugahraun, and bathe in naturally warm streams.",
        "passions": ["adventure", "nature"],
        "lodging": "camper"
      },
      {
        "day": 4,
        "name": "Highlands Traverse to Askja",
        "drive": "🚐 Drive time: ~5-7 hours",
        "start": "",
        "end": "Highlands Traverse to Askja",
        "text": "One of the wildest and most remote days: cross Iceland's interior via F26 or F910, driving through barren black deserts, glacial outwash plains, and surreal landscapes. Spot snowcapped peaks and ancient lava fields. Overnight at Dreki hut near the Askja base.",
        "passions": ["adventure"],
        "lodging": "camper"
      },
      {
        "day": 5,
        "name": "Askja Caldera & Víti Crater",
        "drive": "🚐 Drive time: ~0 hours",
        "start": "",
        "end": "Askja Caldera & Víti Crater",
        "text": "Hike from Dreki into Askja's caldera — eerie, Mars-like terrain of volcanic ash and rock — and discover the bright blue lake of Víti, a geothermal explosion crater. Confident 4x4 drivers can continue themselves, or join a local super-jeep tour. This day is optional and can be skipped to shorten the route.",
        "passions": ["adventure", "nature"],
        "lodging": "camper"
      },
      {
        "day": 6,
        "name": "Möðrudalur & East Fjords",
        "drive": "🚐 Drive time: ~3-4 hours",
        "start": "",
        "end": "Möðrudalur & East Fjords",
        "text": "Exit the highlands via F88 or F905 and stop at Möðrudalur, Iceland's highest working farm with stunning views of Mount Herðubreið. Continue southeast to the East Fjords, with an optional extension to Egilsstaðir for more amenities and nearby waterfalls.",
        "passions": ["scenery"],
        "lodging": "camper"
      },
      {
        "day": 7,
        "name": "South Coast Traverse",
        "drive": "🚐 Drive time: ~4-5 hours",
        "start": "",
        "end": "South Coast Traverse",
        "text": "Scenic South Coast driving with stops at Jökulsárlón glacier lagoon where icebergs drift into the sea, and Diamond Beach with its glittering icebergs on black sand. Optional visits to Skaftafell or Fjaðrárgljúfur canyon en route.",
        "passions": ["nature", "scenery"],
        "lodging": "camper"
      },
      {
        "day": 8,
        "name": "Drop-off",
        "drive": "🚐 Drive time: ~3-3.5 hours",
        "start": "",
        "end": "Drop-off",
        "text": "A final scenic morning with optional visits to Skógafoss waterfall or Reynisfjara beach before returning your 4x4 campervan in Keflavík.",
        "passions": [],
        "lodging": "camper"
      }
    ]
  },
  {
    "id": "iceland-rocks-fire-ice-earth-with-a-campervan",
    "title": "Iceland Rocks – Fire, Ice & Earth with a campervan",
    "passions": ["adventure", "nature", "scenery"],
    "pick_up_country": "Iceland",
    "pick_up_location": "Reykjavik",
    "route_source": "Shopify export",
    "status": "complete",
    "provenance": "hand curated",
    "days_total": 8,
    "distance_km": null,
    "toy": null,
    "days": [
      {
        "day": 1,
        "name": "Arrival & Reykjanes Peninsula",
        "drive": "🚐 Drive time: ~45-60 min",
        "start": "",
        "end": "Arrival & Reykjanes Peninsula",
        "text": "Pick up your campervan in Keflavík and explore the steaming vents and bubbling mud pools near Krýsuvík on the Reykjanes Peninsula. All paved roads and easy gravel.",
        "passions": ["nature"],
        "lodging": "camper"
      },
      {
        "day": 2,
        "name": "Þingvellir National Park",
        "drive": "🚐 Drive time: ~2 hours 15 min",
        "start": "",
        "end": "Þingvellir National Park",
        "text": "Walk between the North American and Eurasian tectonic plates at Almannagjá. Camp by the rift valley and learn about Iceland's volcanic birth. Optional: guided snorkel in Silfra Fissure. All paved access.",
        "passions": ["nature", "scenery"],
        "lodging": "camper"
      },
      {
        "day": 3,
        "name": "Gullfoss, Geysir & Secret Lagoon",
        "drive": "🚐 Drive time: ~1.5 hours",
        "start": "",
        "end": "Gullfoss, Geysir & Secret Lagoon",
        "text": "See Iceland's classic Golden Circle geology — Gullfoss waterfall and erupting geysers — then wind down at the Secret Lagoon. All standard paved routes.",
        "passions": ["nature"],
        "lodging": "camper"
      },
      {
        "day": 4,
        "name": "Hekla & Lava Centre",
        "drive": "🚐 Drive time: ~1.5 hours",
        "start": "",
        "end": "Hekla & Lava Centre",
        "text": "Drive toward the Hekla area on paved roads and visit the interactive Lava Centre in Hvolsvöllur in the afternoon. Any rougher tracks are optional and can be skipped.",
        "passions": ["nature"],
        "lodging": "camper"
      },
      {
        "day": 5,
        "name": "Reynisfjara & Dyrhólaey",
        "drive": "🚐 Drive time: ~1 hour 45 min",
        "start": "",
        "end": "Reynisfjara & Dyrhólaey",
        "text": "Visit the dramatic basalt columns of Reynisfjara black sand beach and the towering Dyrhólaey sea arch. All major roads and access points are paved or well-maintained gravel suitable for 2WD.",
        "passions": ["scenery", "nature"],
        "lodging": "camper"
      },
      {
        "day": 6,
        "name": "Skaftafell & Vatnajökull Edge",
        "drive": "🚐 Drive time: ~2.5 hours",
        "start": "",
        "end": "Skaftafell & Vatnajökull Edge",
        "text": "Optional glacier hike from the Skaftafell visitor centre on the edge of Vatnajökull, Europe's largest glacier. Stick to paved roads and marked trails — no 4x4 needed.",
        "passions": ["adventure", "nature"],
        "lodging": "camper"
      },
      {
        "day": 7,
        "name": "Return West via Eldhraun Lava Fields",
        "drive": "🚐 Drive time: ~4-5 hours",
        "start": "",
        "end": "Return West via Eldhraun Lava Fields",
        "text": "Drive back through the haunting moss-covered Eldhraun lava fields along Route 1. Avoid F-roads and detours requiring 4x4; stick to Route 1 with optional short walks to geothermal spots.",
        "passions": ["scenery"],
        "lodging": "camper"
      },
      {
        "day": 8,
        "name": "Drop-off",
        "drive": "🚐 Drive time: ~4.5 hours",
        "start": "",
        "end": "Drop-off",
        "text": "Return your campervan in Keflavík. Optional final soak at the Blue Lagoon (pre-booking essential).",
        "passions": [],
        "lodging": "camper"
      }
    ]
  },
  {
    "id": "ultimate-luxury-campervan-experience-us-and-canada",
    "title": "Ultimate Luxury RV Experience: Explore US & Canada in Style",
    "passions": ["luxury"],
    "pick_up_country": "US",
    "pick_up_location": "",
    "route_source": "Shopify export",
    "status": "coming soon",
    "provenance": "hand curated",
    "days_total": null,
    "distance_km": null,
    "toy": null,
    "days": []
  },
  {
    "id": "valderrama-andaluc-a-spain",
    "title": "White Villages & Ryder Cup Greens on an Andalusian Campervan Road-trip",
    "passions": ["golf", "wine", "scenery"],
    "pick_up_country": "Spain",
    "pick_up_location": "Malaga",
    "route_source": "Shopify export",
    "status": "complete",
    "provenance": "hand curated",
    "days_total": 9,
    "distance_km": null,
    "toy": null,
    "days": [
      {
        "day": 1,
        "name": "Arrival in Málaga & Marbella",
        "drive": "🚐 Drive time: ~1 hour",
        "start": "",
        "end": "Arrival in Málaga & Marbella",
        "text": "Pick up your campervan and drive the coastal highway past fishing villages, citrus groves, and coastal cliffs. Explore Marbella's elegant old town featuring Moorish architecture and whitewashed alleys. Enjoy wine in Plaza de los Naranjos while watching the Mediterranean sunset.",
        "passions": ["scenery"],
        "lodging": "camper"
      },
      {
        "day": 2,
        "name": "Marbella Club Golf Resort",
        "drive": "🚐 Drive time: ~20 min",
        "start": "",
        "end": "Marbella Club Golf Resort",
        "text": "Play this lush course framed by Sierra Blanca mountains. Fairways weave among pines and olive trees, and the sea glimmers in the distance. Marbella's golf scene established the Costa del Sol as a luxury destination.",
        "passions": ["golf"],
        "lodging": "camper"
      },
      {
        "day": 3,
        "name": "Ronda & Jerez Transition",
        "drive": "🚐 Drive time: ~2 hours",
        "start": "",
        "end": "Ronda & Jerez Transition",
        "text": "Cross rolling hills and vineyards to Ronda, perched on cliffs above a deep gorge. Visit the 18th-century bullring and Arab Baths, sampling local cheeses and wines. Continue to Jerez, the sherry capital, where bodegas and equestrian traditions define the culture.",
        "passions": ["wine", "scenery"],
        "lodging": "camper"
      },
      {
        "day": 4,
        "name": "Montecastillo Golf Resort",
        "drive": "🚐 Drive time: ~15 min",
        "start": "",
        "end": "Montecastillo Golf Resort",
        "text": "Play this Jack Nicklaus-designed course, host of the Volvo Masters and a Ryder Cup venue. Expect wide fairways, sweeping bunkers, and water hazards. Spend the evening touring a historic sherry bodega.",
        "passions": ["golf", "wine"],
        "lodging": "camper"
      },
      {
        "day": 5,
        "name": "Jerez & Costa de la Luz",
        "drive": "🚐 Drive time: ~1 hour",
        "start": "",
        "end": "Jerez & Costa de la Luz",
        "text": "Spend the morning at the Royal Andalusian School of Equestrian Art, famous for preserving Spanish dressage. Drive to Costa de la Luz, featuring golden dunes and fishing villages.",
        "passions": ["scenery"],
        "lodging": "camper"
      },
      {
        "day": 6,
        "name": "Cádiz Coast & Beaches",
        "drive": "🚐 Drive time: ~0 hours",
        "start": "",
        "end": "Cádiz Coast & Beaches",
        "text": "Relax on endless beaches like Bolonia, where Roman ruins meet Atlantic waves. Try grilled sardines and local wines in beachfront chiringuitos.",
        "passions": ["scenery"],
        "lodging": "camper"
      },
      {
        "day": 7,
        "name": "Alcaidesa Links Golf",
        "drive": "🚐 Drive time: ~1 hour",
        "start": "",
        "end": "Alcaidesa Links Golf",
        "text": "Tee off overlooking the Rock of Gibraltar. The links-style layout and sea breezes recall Scottish traditions transplanted to Andalucía.",
        "passions": ["golf", "scenery"],
        "lodging": "camper"
      },
      {
        "day": 8,
        "name": "Valderrama Golf Club & Return",
        "drive": "🚐 Drive time: ~1.5 hours",
        "start": "",
        "end": "Valderrama Golf Club & Return",
        "text": "End your trip on the course that hosted the 1997 Ryder Cup. Valderrama is Europe's crown jewel, famous for perfect fairways among Mediterranean pines. After your round and gourmet lunch, return to Málaga.",
        "passions": ["golf"],
        "lodging": "camper"
      },
      {
        "day": 9,
        "name": "Departure from Málaga",
        "drive": "🚐 Drive time: ~0 hours",
        "start": "",
        "end": "Departure from Málaga",
        "text": "Return your campervan and enjoy breakfast in Málaga's old port before flying home.",
        "passions": [],
        "lodging": "camper"
      }
    ]
  },
  {
    "id": "gibson-ridge-vineyard-retreat-the-restorative-highlight-of-your-south-island-adventure",
    "title": "Vineyard Stay & Taste: The Highlight of Your NZ South Island Adventure",
    "passions": ["wine", "scenery", "nature"],
    "pick_up_country": "New Zealand",
    "pick_up_location": "Christchurch",
    "route_source": "Shopify export",
    "status": "complete",
    "provenance": "hand curated",
    "days_total": 14,
    "distance_km": null,
    "toy": null,
    "days": [
      {
        "day": 1,
        "name": "Arrival in Christchurch",
        "drive": "🚐 Drive time: ~0 hours",
        "start": "",
        "end": "Arrival in Christchurch",
        "text": "Fly into Christchurch and pick up your campervan. Spend the evening exploring the revitalised city centre or relaxing in the foothills. Stock up on supplies and enjoy your first night under New Zealand skies.",
        "passions": [],
        "lodging": "camper"
      },
      {
        "day": 2,
        "name": "Lake Tekapo",
        "drive": "🚐 Drive time: ~3 hours",
        "start": "",
        "end": "Lake Tekapo",
        "text": "Head into Mackenzie Country, a region known for its wide skies and glacial lakes. Visit the iconic Church of the Good Shepherd, stroll lakeside trails, and prepare for an evening of world-class stargazing in this designated Dark Sky Reserve.",
        "passions": ["scenery", "nature"],
        "lodging": "camper"
      },
      {
        "day": 3,
        "name": "Aoraki/Mount Cook",
        "drive": "🚐 Drive time: ~1.5 hours",
        "start": "",
        "end": "Aoraki/Mount Cook",
        "text": "Drive deeper into the Southern Alps and explore Mount Cook National Park. Hike the Hooker Valley Track for epic mountain views or book a scenic flight. Stay the night with views of New Zealand's highest peak.",
        "passions": ["nature", "scenery"],
        "lodging": "camper"
      },
      {
        "day": 4,
        "name": "Queenstown via Lindis Pass",
        "drive": "🚐 Drive time: ~3.5 hours",
        "start": "",
        "end": "Queenstown via Lindis Pass",
        "text": "Cross one of South Island's most dramatic mountain passes, stopping at lookouts along the way. Arrive in Queenstown and enjoy the lakeside boardwalk, boutique shops, and a cosy dinner in this lively alpine town.",
        "passions": ["scenery"],
        "lodging": "camper"
      },
      {
        "day": 5,
        "name": "Queenstown Thrills",
        "drive": "🚐 Drive time: ~0 hours",
        "start": "",
        "end": "Queenstown Thrills",
        "text": "Spend the day diving into Queenstown's adrenaline-packed offerings. Bungy jump off Kawarau Bridge, speed down the Shotover River, or ride the Skyline Gondola for panoramic views and luge runs. Round off the day with a wine bar or lake cruise.",
        "passions": ["adventure"],
        "lodging": "camper"
      },
      {
        "day": 6,
        "name": "Glenorchy",
        "drive": "🚐 Drive time: ~0 hours",
        "start": "",
        "end": "Glenorchy",
        "text": "Take a slow, stunning drive north along Lake Wakatipu to Glenorchy. Enjoy a gentle walk through beech forests or go horse trekking through filming locations from The Lord of the Rings. Picnic beside the Dart River.",
        "passions": ["nature", "scenery"],
        "lodging": "camper"
      },
      {
        "day": 7,
        "name": "Franz Josef",
        "drive": "🚐 Drive time: ~5 hours",
        "start": "",
        "end": "Franz Josef",
        "text": "Wind your way through the Haast Pass into the wild, wet, and lush West Coast. Visit waterfalls like Thunder Creek and Monro Beach before settling near Franz Josef Glacier.",
        "passions": ["scenery", "nature"],
        "lodging": "camper"
      },
      {
        "day": 8,
        "name": "Glacier Adventure",
        "drive": "🚐 Drive time: ~0 hours",
        "start": "",
        "end": "Glacier Adventure",
        "text": "Take a guided glacier walk or helicopter flight to ice caves. In the afternoon, soak in Franz Josef's outdoor hot pools nestled in rainforest.",
        "passions": ["adventure", "nature"],
        "lodging": "camper"
      },
      {
        "day": 9,
        "name": "Abel Tasman Region",
        "drive": "🚐 Drive time: ~6 hours",
        "start": "",
        "end": "Abel Tasman Region",
        "text": "Begin the long, scenic drive north to Abel Tasman National Park. Arrive in Kaiteriteri or Marahau and relax near the coast.",
        "passions": ["scenery"],
        "lodging": "camper"
      },
      {
        "day": 10,
        "name": "Abel Tasman National Park",
        "drive": "🚐 Drive time: ~0 hours",
        "start": "",
        "end": "Abel Tasman National Park",
        "text": "Explore New Zealand's smallest and sunniest national park by kayak or on foot. Golden beaches, turquoise water, and lush forest trails await. Don't miss Cleopatra's Pool or a water taxi ride to remote coves.",
        "passions": ["nature", "adventure"],
        "lodging": "camper"
      },
      {
        "day": 11,
        "name": "Marlborough/Renwick",
        "drive": "🚐 Drive time: ~2.5 hours",
        "start": "",
        "end": "Marlborough/Renwick",
        "text": "Make your way to Renwick, the heart of Marlborough wine country. Settle in at Gibson Bridge Vineyard and enjoy a quiet evening among the vines.",
        "passions": ["wine"],
        "lodging": "camper"
      },
      {
        "day": 12,
        "name": "Wine Tasting & Relaxation",
        "drive": "🚐 Drive time: ~0 hours",
        "start": "",
        "end": "Wine Tasting & Relaxation",
        "text": "Wake up to vineyard tranquillity. Join a hosted wine tasting with Howard & Julie, then explore local wineries by bike or foot. Spend the afternoon reading, sketching, or sipping under the trees.",
        "passions": ["wine"],
        "lodging": "camper"
      },
      {
        "day": 13,
        "name": "Kaikoura Coast",
        "drive": "🚐 Drive time: ~2.5 hours",
        "start": "",
        "end": "Kaikoura Coast",
        "text": "Drive south to the coast and set up camp by the sea. Go whale watching, visit the fur seal colony, or simply enjoy a seafood lunch with an ocean view.",
        "passions": ["nature", "scenery"],
        "lodging": "camper"
      },
      {
        "day": 14,
        "name": "Return to Christchurch",
        "drive": "🚐 Drive time: ~2.5 hours",
        "start": "",
        "end": "Return to Christchurch",
        "text": "Wind your way back toward Christchurch with stops at scenic viewpoints or roadside vineyards. Enjoy your final evening in a boutique hotel or camper site near the airport.",
        "passions": [],
        "lodging": "camper"
      }
    ]
  },
  {
    "id": "nz-south-island-stars-suspension-bridges-scenery",
    "title": "New Zealand South Island: Stars, Suspension Bridges & Scenery",
    "passions": ["scenery", "nature", "stargazing", "walks", "food", "scenic driving"],
    "pick_up_country": "New Zealand",
    "pick_up_location": "Christchurch",
    "route_source": "Shopify export",
    "status": "complete",
    "provenance": "hand curated",
    "days_total": "9-11",
    "distance_km": 1470,
    "toy": null,
    "days": [
      {
        "day": 1,
        "name": "Arrive Christchurch",
        "drive": "🚐 Drive time: — (airport transfers only)",
        "start": "",
        "end": "Arrive Christchurch",
        "text": "Arrive in the afternoon, collect the motorhome, complete handover/orientation (typically 60–90 min), and stay close to Christchurch so the first day stays relaxed and in daylight. A short evening walk in the Botanic Gardens is an easy way to reset.",
        "passions": [],
        "lodging": "camper"
      },
      {
        "day": 2,
        "name": "Christchurch to Lake Tekapo",
        "drive": "🚐 Drive time: 2 h 30 min",
        "start": "",
        "end": "Christchurch to Lake Tekapo",
        "text": "Head south across open farmland toward the Mackenzie Basin. As Tekapo's turquoise water and the Southern Alps come into view, settle in and walk to the Church of the Good Shepherd; if it's clear, this is one of NZ's best night-sky locations (International Dark Sky Reserve).",
        "passions": ["stargazing", "scenery"],
        "lodging": "camper",
        "experiences": ["lake-tekapo-dark-sky-stargazing"]
      },
      {
        "day": 3,
        "name": "Lake Tekapo to Wānaka",
        "drive": "🚐 Drive time: 3 h 00 min",
        "start": "",
        "end": "Lake Tekapo to Wānaka",
        "text": "Drive the high-country valleys and the Lindis Pass before dropping into Wānaka's lake setting. Stroll the flat foreshore to the \"That Wānaka Tree,\" or take a short headland path for open views. Keep the evening easy with a relaxed dinner in town.",
        "passions": ["scenery"],
        "lodging": "camper"
      },
      {
        "day": 4,
        "name": "Wānaka to Fox Glacier",
        "drive": "🚐 Drive time: 3 h 30 min",
        "start": "",
        "end": "Wānaka to Fox Glacier",
        "text": "This is one of NZ's finest drives: over Haast Pass past blue pools and waterfalls, then along a wild West Coast of rainforest, rivers and black-sand beaches. In Fox Glacier village, the easy Lake Matheson loop (1–1.5 hrs) often gives classic mirror views of Aoraki/Mt Cook.",
        "passions": ["scenery", "nature"],
        "lodging": "camper",
        "experiences": ["fox-glacier-heli-snow-landing", "lake-matheson-mirror-walk"]
      },
      {
        "day": 5,
        "name": "Fox Glacier to Hokitika",
        "drive": "🚐 Drive time: 2 h 15 min",
        "start": "",
        "end": "Fox Glacier to Hokitika",
        "text": "Follow SH6 north past river mouths, rainforest and small settlements to walkable, characterful Hokitika. The Hokitika Gorge loop (easy, ~45–60 min) is a highlight: firm paths, bright blue water and a suspension bridge set in lush forest.",
        "passions": ["nature", "scenery"],
        "lodging": "camper",
        "experiences": ["hokitika-gorge-suspension-bridge-walk"]
      },
      {
        "day": 6,
        "name": "Hokitika to Arthur's Pass",
        "drive": "🚐 Drive time: 2 h",
        "start": "",
        "end": "Hokitika to Arthur's Pass",
        "text": "Climb from the coast through the Otira Viaduct into Arthur's Pass National Park. Short tracks give immediate access to valley and waterfall views (e.g., Devil's Punchbowl Falls, ~1 h return). Include the side trip to Lake Pearson and Castle Hill/Kura Tāwhiti for limestone outcrops and open basin views.",
        "passions": ["nature", "scenery"],
        "lodging": "camper",
        "experiences": ["castle-hill-kura-tawhiti-walk"]
      },
      {
        "day": 7,
        "name": "Arthur's Pass to Murchison",
        "drive": "🚐 Drive time: 3 h 45 min",
        "start": "",
        "end": "Arthur's Pass to Murchison",
        "text": "Descend the eastern side and turn north toward Lewis Pass and the Buller River. Murchison is a friendly farming town, a good place for a motorhome-friendly farmstay, local conversation, and a slower evening in open countryside.",
        "passions": ["nature"],
        "lodging": "camper",
        "experiences": ["murchison-farmstay-swing-bridge"]
      },
      {
        "day": 8,
        "name": "Murchison to Nelson to Picton",
        "drive": "🚐 Drive time: 3 h 30 min",
        "start": "",
        "end": "Murchison to Nelson to Picton",
        "text": "Quiet valleys lead toward the coast and then through rolling country to Picton, gateway to the North Island. Choose a compact culture stop in Nelson (Classic Car Museum) or turn east earlier into the Marlborough hills for a vineyard lunch/tasting.",
        "passions": ["food", "scenic driving"],
        "lodging": "camper",
        "experiences": ["nelson-classic-car-museum", "marlborough-vineyard-tasting"]
      },
      {
        "day": 9,
        "name": "Picton (Depart)",
        "drive": "🚐 Drive time: —",
        "start": "",
        "end": "Picton (Depart)",
        "text": "Return motorhome at the ferry terminal before onward travel. If timing allows, a short waterfront walk and coffee make for a relaxed send-off.",
        "passions": [],
        "lodging": "camper"
      }
    ]
  },
  {
    "id": "tarawera-ultra-trail-run-rotorua",
    "title": "🏁 Tarawera Ultra-Trail + Run Rotorua, Taupō & Bay of Islands (Trip dates: 1-8th Feb '26)",
    "passions": ["running", "adventure"],
    "pick_up_country": "New Zealand",
    "pick_up_location": "Auckland",
    "route_source": "Shopify export",
    "status": "coming soon",
    "provenance": "hand curated",
    "days_total": null,
    "distance_km": null,
    "toy": null,
    "days": []
  },
  {
    "id": "golf-new-zealands-north-island-including-cape-kidnappers-golfing-package",
    "title": "Cape Kidnappers, Vineyards & Hot Springs",
    "passions": ["golf", "wine", "scenery"],
    "pick_up_country": "New Zealand",
    "pick_up_location": "Auckland",
    "route_source": "Shopify export",
    "status": "complete",
    "provenance": "hand curated",
    "days_total": 12,
    "distance_km": null,
    "toy": null,
    "days": [
      {
        "day": 1,
        "name": "Auckland Arrival & Pick-Up",
        "drive": "🚐 Drive time: ~3.5-4 hours",
        "start": "",
        "end": "Auckland Arrival & Pick-Up",
        "text": "Collect your spacious campervan in Auckland and begin your journey through rolling farmland to Lake Taupo, New Zealand's largest lake, framed by volcanic peaks.",
        "passions": ["scenery"],
        "lodging": "camper"
      },
      {
        "day": 2,
        "name": "Lake Taupo & Geothermal Soaking",
        "drive": "🚐 Drive time: ~0 hours",
        "start": "",
        "end": "Lake Taupo & Geothermal Soaking",
        "text": "Enjoy kayaking or stand-up paddleboarding in clear waters, then soak in the Otumuheke Stream hot pools and dine lakeside as the sun goes down.",
        "passions": ["nature"],
        "lodging": "camper"
      },
      {
        "day": 3,
        "name": "Wairakei Golf + Sanctuary",
        "drive": "🚐 Drive time: ~15 min",
        "start": "",
        "end": "Wairakei Golf + Sanctuary",
        "text": "Tee off at Wairakei, a course ranked in NZ's top 5. The fairways wind through a predator-free sanctuary with native birds. Overnight parking at the course is available.",
        "passions": ["golf", "nature"],
        "lodging": "camper"
      },
      {
        "day": 4,
        "name": "Rotorua Geysers & Redwood Trails",
        "drive": "🚐 Drive time: ~1.5 hours",
        "start": "",
        "end": "Rotorua Geysers & Redwood Trails",
        "text": "Drive to Rotorua to witness bubbling mud pools and erupting geysers. Walk among towering redwoods or learn about Maori traditions at Te Puia.",
        "passions": ["nature"],
        "lodging": "camper"
      },
      {
        "day": 5,
        "name": "Te Mata Peak & Napier",
        "drive": "🚐 Drive time: ~3.5 hours",
        "start": "",
        "end": "Te Mata Peak & Napier",
        "text": "Climb Te Mata Peak for panoramic views over Hawke's Bay vineyards, then descend to Napier's art deco streets.",
        "passions": ["scenery", "wine"],
        "lodging": "camper"
      },
      {
        "day": 6,
        "name": "Cape Kidnappers Golf",
        "drive": "🚐 Drive time: ~25 min",
        "start": "",
        "end": "Cape Kidnappers Golf",
        "text": "Experience a bucket-list round on dramatic cliffside fairways. Cape Kidnappers is ranked among the top 50 in the world. The clubhouse restaurant is renowned for gourmet cuisine and local wines.",
        "passions": ["golf"],
        "lodging": "camper"
      },
      {
        "day": 7,
        "name": "Ohope Beach",
        "drive": "🚐 Drive time: ~4.5 hours",
        "start": "",
        "end": "Ohope Beach",
        "text": "Head north along scenic coastal highways to Ohope Beach, known for its relaxed vibe and sweeping sands.",
        "passions": ["scenery"],
        "lodging": "camper"
      },
      {
        "day": 8,
        "name": "Ohope International Golf Club",
        "drive": "🚐 Drive time: ~0 hours",
        "start": "",
        "end": "Ohope International Golf Club",
        "text": "Play 18 ocean-view holes at this laid-back links course ranked in NZ's top 20. The club features a casual restaurant with outdoor seating.",
        "passions": ["golf"],
        "lodging": "camper"
      },
      {
        "day": 9,
        "name": "Drive North Toward Bay of Islands",
        "drive": "🚐 Drive time: ~4-5 hours",
        "start": "",
        "end": "Drive North Toward Bay of Islands",
        "text": "Travel north with optional stops in Whangarei's waterfalls or craft markets. Overnight at a peaceful campsite surrounded by native bush.",
        "passions": ["scenery"],
        "lodging": "camper"
      },
      {
        "day": 10,
        "name": "Waitangi Golf Club & Bay of Islands",
        "drive": "🚐 Drive time: ~1 hour",
        "start": "",
        "end": "Waitangi Golf Club & Bay of Islands",
        "text": "Tee off with spectacular views over the Bay of Islands. This relaxed course is known for its friendly atmosphere.",
        "passions": ["golf", "scenery"],
        "lodging": "camper"
      },
      {
        "day": 11,
        "name": "Return to Auckland",
        "drive": "🚐 Drive time: ~3.5-4 hours",
        "start": "",
        "end": "Return to Auckland",
        "text": "Drive south, stopping for lunch in Matakana wine country or along Orewa's beaches.",
        "passions": ["wine"],
        "lodging": "camper"
      },
      {
        "day": 12,
        "name": "Auckland Drop-Off & Departure",
        "drive": "🚐 Drive time: ~0 hours",
        "start": "",
        "end": "Auckland Drop-Off & Departure",
        "text": "Return your campervan and enjoy a final breakfast in Ponsonby or a stroll up Mt Eden.",
        "passions": [],
        "lodging": "camper"
      }
    ]
  }
]
;